// This file is auto-generated by @hey-api/openapi-ts

import {
  type Client,
  formDataBodySerializer,
  type Options as Options2,
  type TDataShape,
} from './client';
import { client } from './client.gen';
import type {
  AcceptInvitationData,
  AcceptInvitationErrors,
  AcceptInvitationResponses,
  AddAccountTypeData,
  AddAccountTypeErrors,
  AddAccountTypeResponses,
  AddApplicationCommentData,
  AddApplicationCommentErrors,
  AddApplicationCommentResponses,
  ApplyAndStartInstantData,
  ApplyAndStartInstantErrors,
  ApplyAndStartInstantResponses,
  ApproveMcpAuthRequestData,
  ApproveMcpAuthRequestErrors,
  ApproveMcpAuthRequestResponses,
  ArchiveApplicationApplicationsArchivePostData,
  ArchiveApplicationApplicationsArchivePostErrors,
  ArchiveApplicationApplicationsArchivePostResponses,
  AssessRecordingsAdvancedData,
  AssessRecordingsAdvancedErrors,
  AssessRecordingsAdvancedResponses,
  AssessRecordingsData,
  AssessRecordingsErrors,
  AssessRecordingsResponses,
  AssessSessionData,
  AssessSessionErrors,
  AssessSessionResponses,
  BulkDeleteByFilterData,
  BulkDeleteByFilterErrors,
  BulkDeleteByFilterResponses,
  CancelEvalExperimentData,
  CancelEvalExperimentErrors,
  CancelEvalExperimentResponses,
  CancelInterviewData,
  CancelInterviewErrors,
  CancelInterviewPublicData,
  CancelInterviewPublicErrors,
  CancelInterviewPublicResponses,
  CancelInterviewResponses,
  ChatFollowupData,
  ChatFollowupErrors,
  ChatFollowupResponses,
  CheckCameraData,
  CheckCameraErrors,
  CheckCameraResponses,
  CheckDomainPublicPublicCompaniesDomainCheckPublicIdGetData,
  CheckDomainPublicPublicCompaniesDomainCheckPublicIdGetErrors,
  CheckDomainPublicPublicCompaniesDomainCheckPublicIdGetResponses,
  CheckEmailExistsData,
  CheckEmailExistsErrors,
  CheckEmailExistsResponses,
  CheckProvidersHealthHealthProvidersGetData,
  CheckProvidersHealthHealthProvidersGetResponses,
  CreateCandidateApplicationPublicPublicSessionsCandidateApplicationPostData,
  CreateCandidateApplicationPublicPublicSessionsCandidateApplicationPostErrors,
  CreateCandidateApplicationPublicPublicSessionsCandidateApplicationPostResponses,
  CreateDemoVideoData,
  CreateDemoVideoErrors,
  CreateDemoVideoResponses,
  CreateEvalExperimentData,
  CreateEvalExperimentErrors,
  CreateEvalExperimentResponses,
  CreateEvalFixtureData,
  CreateEvalFixtureErrors,
  CreateEvalFixtureResponses,
  CreateEvalReplayData,
  CreateEvalReplayErrors,
  CreateEvalReplayResponses,
  CreateEvaluatorData,
  CreateEvaluatorErrors,
  CreateEvaluatorResponses,
  CreateSessionGroupData,
  CreateSessionGroupErrors,
  CreateSessionGroupResponses,
  CreateStageData,
  CreateStageErrors,
  CreateStageResponses,
  CreateTemplateTemplatesPostData,
  CreateTemplateTemplatesPostErrors,
  CreateTemplateTemplatesPostResponses,
  CreateTestSessionsTestSessionPostData,
  CreateTestSessionsTestSessionPostErrors,
  CreateTestSessionsTestSessionPostResponses,
  CreateUserWithCompanyData,
  CreateUserWithCompanyErrors,
  CreateUserWithCompanyResponses,
  DeclineInvitationData,
  DeclineInvitationErrors,
  DeclineInvitationResponses,
  DeleteApplicationsApplicationsDeleteApplicationsDeleteData,
  DeleteApplicationsApplicationsDeleteApplicationsDeleteErrors,
  DeleteApplicationsApplicationsDeleteApplicationsDeleteResponses,
  DeleteKnowledgeItemData,
  DeleteKnowledgeItemErrors,
  DeleteKnowledgeItemResponses,
  DeleteMemberMembersUserIdDeleteData,
  DeleteMemberMembersUserIdDeleteErrors,
  DeleteMemberMembersUserIdDeleteResponses,
  DeleteRecordingRecordingsRecordingRoomIdDeleteData,
  DeleteRecordingRecordingsRecordingRoomIdDeleteErrors,
  DeleteRecordingRecordingsRecordingRoomIdDeleteResponses,
  DeleteSessionGroupData,
  DeleteSessionGroupErrors,
  DeleteSessionGroupResponses,
  DeleteStageData,
  DeleteStageErrors,
  DeleteStageResponses,
  DeleteTemplateTemplatesTemplateIdDeleteData,
  DeleteTemplateTemplatesTemplateIdDeleteErrors,
  DeleteTemplateTemplatesTemplateIdDeleteResponses,
  DenyMcpAuthRequestData,
  DenyMcpAuthRequestErrors,
  DenyMcpAuthRequestResponses,
  DescribeImageTaskPublicKnowledgeDescribeImagePostData,
  DescribeImageTaskPublicKnowledgeDescribeImagePostErrors,
  DescribeImageTaskPublicKnowledgeDescribeImagePostResponses,
  DisableTemplateSharingTemplatesTemplateIdShareDeleteData,
  DisableTemplateSharingTemplatesTemplateIdShareDeleteErrors,
  DisableTemplateSharingTemplatesTemplateIdShareDeleteResponses,
  EnableTemplateSharingTemplatesTemplateIdSharePostData,
  EnableTemplateSharingTemplatesTemplateIdSharePostErrors,
  EnableTemplateSharingTemplatesTemplateIdSharePostResponses,
  EnrollInSessionGroupData,
  EnrollInSessionGroupErrors,
  EnrollInSessionGroupResponses,
  EvaluateAllEvalRunsData,
  EvaluateAllEvalRunsErrors,
  EvaluateAllEvalRunsResponses,
  EvaluateEvalExperimentData,
  EvaluateEvalExperimentErrors,
  EvaluateEvalExperimentResponses,
  EvaluateEvalRunData,
  EvaluateEvalRunErrors,
  EvaluateEvalRunResponses,
  ExportRoomSummaryCsvData,
  ExportRoomSummaryCsvErrors,
  ExportRoomSummaryCsvResponses,
  ExportRoomSummaryPdfData,
  ExportRoomSummaryPdfErrors,
  ExportRoomSummaryPdfResponses,
  ExtractListeningTaskPublicKnowledgeExtractListeningPostData,
  ExtractListeningTaskPublicKnowledgeExtractListeningPostErrors,
  ExtractListeningTaskPublicKnowledgeExtractListeningPostResponses,
  ExtractMaterialTaskPublicKnowledgeExtractMaterialPostData,
  ExtractMaterialTaskPublicKnowledgeExtractMaterialPostErrors,
  ExtractMaterialTaskPublicKnowledgeExtractMaterialPostResponses,
  FetchYoutubeTaskPublicKnowledgeFetchYoutubePostData,
  FetchYoutubeTaskPublicKnowledgeFetchYoutubePostErrors,
  FetchYoutubeTaskPublicKnowledgeFetchYoutubePostResponses,
  ForkReviewSessionData,
  ForkReviewSessionErrors,
  ForkReviewSessionResponses,
  GenerateApiKeyEndpointUsersGenerateKeyPostData,
  GenerateApiKeyEndpointUsersGenerateKeyPostErrors,
  GenerateApiKeyEndpointUsersGenerateKeyPostResponses,
  GenerateBulkSummariesRoomsGenerateSummaryPostData,
  GenerateBulkSummariesRoomsGenerateSummaryPostErrors,
  GenerateBulkSummariesRoomsGenerateSummaryPostResponses,
  GenerateKnowledgeImagesData,
  GenerateKnowledgeImagesErrors,
  GenerateKnowledgeImagesResponses,
  GenerateLearningPathChatData,
  GenerateLearningPathChatErrors,
  GenerateLearningPathChatResponses,
  GenerateLearningPathData,
  GenerateLearningPathErrors,
  GenerateLearningPathResponses,
  GenerateSessionByTemplatePublicGenerateSessionByTemplatePostData,
  GenerateSessionByTemplatePublicGenerateSessionByTemplatePostErrors,
  GenerateSessionByTemplatePublicGenerateSessionByTemplatePostResponses,
  GenerateSessionTemplateAiGenerationSessionTemplatePostData,
  GenerateSessionTemplateAiGenerationSessionTemplatePostErrors,
  GenerateSessionTemplateAiGenerationSessionTemplatePostResponses,
  GenerateSingleSummaryLivekitGenerateSingleSummaryPostData,
  GenerateSingleSummaryLivekitGenerateSingleSummaryPostErrors,
  GenerateSingleSummaryLivekitGenerateSingleSummaryPostResponses,
  GenerateUserLearningPathData,
  GenerateUserLearningPathErrors,
  GenerateUserLearningPathResponses,
  GetAllAssessmentComponentsData,
  GetAllAssessmentComponentsResponses,
  GetApplicationCommentsData,
  GetApplicationCommentsErrors,
  GetApplicationCommentsResponses,
  GetAuditLogsGdprAuditLogsGetData,
  GetAuditLogsGdprAuditLogsGetErrors,
  GetAuditLogsGdprAuditLogsGetResponses,
  GetAvailabilityPublicPublicSessionsAvailabilityGetData,
  GetAvailabilityPublicPublicSessionsAvailabilityGetErrors,
  GetAvailabilityPublicPublicSessionsAvailabilityGetResponses,
  GetAvailableLlmModelsData,
  GetAvailableLlmModelsErrors,
  GetAvailableLlmModelsResponses,
  GetCandidateFeedbackData,
  GetCandidateFeedbackErrors,
  GetCandidateFeedbackResponses,
  GetCandidateLearnRecommendationsData,
  GetCandidateLearnRecommendationsErrors,
  GetCandidateLearnRecommendationsResponses,
  GetCandidatePublicPublicCandidatesApplicationIdGetData,
  GetCandidatePublicPublicCandidatesApplicationIdGetErrors,
  GetCandidatePublicPublicCandidatesApplicationIdGetResponses,
  GetCandidatesCountData,
  GetCandidatesCountErrors,
  GetCandidatesCountResponses,
  GetCandidatesPublicPublicCandidatesGetData,
  GetCandidatesPublicPublicCandidatesGetErrors,
  GetCandidatesPublicPublicCandidatesGetResponses,
  GetCandidatesRoomsCandidatesGetData,
  GetCandidatesRoomsCandidatesGetErrors,
  GetCandidatesRoomsCandidatesGetResponses,
  GetCompanyCompaniesSingleGetData,
  GetCompanyCompaniesSingleGetErrors,
  GetCompanyCompaniesSingleGetResponses,
  GetCompanyInsightsData,
  GetCompanyInsightsErrors,
  GetCompanyInsightsResponses,
  GetComplianceStatusGdprComplianceStatusGetData,
  GetComplianceStatusGdprComplianceStatusGetErrors,
  GetComplianceStatusGdprComplianceStatusGetResponses,
  GetConversationTranscriptionPublicPublicRecordingsConversationTranscriptionIdGetData,
  GetConversationTranscriptionPublicPublicRecordingsConversationTranscriptionIdGetErrors,
  GetConversationTranscriptionPublicPublicRecordingsConversationTranscriptionIdGetResponses,
  GetConversationTranscriptionRecordingsConversationTranscriptionIdGetData,
  GetConversationTranscriptionRecordingsConversationTranscriptionIdGetErrors,
  GetConversationTranscriptionRecordingsConversationTranscriptionIdGetResponses,
  GetDefaultAssessmentComponentsData,
  GetDefaultAssessmentComponentsResponses,
  GetDeletionStatusGdprDeletionStatusJobIdGetData,
  GetDeletionStatusGdprDeletionStatusJobIdGetErrors,
  GetDeletionStatusGdprDeletionStatusJobIdGetResponses,
  GetDemoVideoData,
  GetDemoVideoErrors,
  GetDemoVideoResponses,
  GetEvalDashboardData,
  GetEvalDashboardErrors,
  GetEvalDashboardResponses,
  GetEvalExperimentData,
  GetEvalExperimentErrors,
  GetEvalExperimentResponses,
  GetEvalFixturePromptsData,
  GetEvalFixturePromptsErrors,
  GetEvalFixturePromptsResponses,
  GetEvalLabelingQueueData,
  GetEvalLabelingQueueErrors,
  GetEvalLabelingQueueResponses,
  GetEvalLabelQueueData,
  GetEvalLabelQueueErrors,
  GetEvalLabelQueueResponses,
  GetEvalOptionsData,
  GetEvalOptionsErrors,
  GetEvalOptionsResponses,
  GetEvalReplayData,
  GetEvalReplayErrors,
  GetEvalReplayResponses,
  GetEvaluatorData,
  GetEvaluatorErrors,
  GetEvaluatorResponses,
  GetEvalWatchTokenData,
  GetEvalWatchTokenErrors,
  GetEvalWatchTokenResponses,
  GetExportStatusGdprExportExportIdStatusGetData,
  GetExportStatusGdprExportExportIdStatusGetErrors,
  GetExportStatusGdprExportExportIdStatusGetResponses,
  GetFeaturedSessionGroupsData,
  GetFeaturedSessionGroupsResponses,
  GetGdprQueueStatusData,
  GetGdprQueueStatusErrors,
  GetGdprQueueStatusResponses,
  GetGroupVisualizationStatusData,
  GetGroupVisualizationStatusErrors,
  GetGroupVisualizationStatusResponses,
  GetHealthGetData,
  GetHealthGetResponses,
  GetKnowledgeByTemplateData,
  GetKnowledgeByTemplateErrors,
  GetKnowledgeByTemplateResponses,
  GetKnowledgeHlsManifestData,
  GetKnowledgeHlsManifestErrors,
  GetKnowledgeHlsManifestResponses,
  GetKnowledgeHlsPlaylistData,
  GetKnowledgeHlsPlaylistErrors,
  GetKnowledgeHlsPlaylistResponses,
  GetKnowledgeMaterialSignedUrlData,
  GetKnowledgeMaterialSignedUrlErrors,
  GetKnowledgeMaterialSignedUrlResponses,
  GetLeadsData,
  GetLeadsErrors,
  GetLeadSessionRoomsData,
  GetLeadSessionRoomsErrors,
  GetLeadSessionRoomsResponses,
  GetLeadSessionsData,
  GetLeadSessionsErrors,
  GetLeadSessionsResponses,
  GetLeadsResponses,
  GetLearnCategoriesData,
  GetLearnCategoriesResponses,
  GetLearningDocumentData,
  GetLearningDocumentErrors,
  GetLearningDocumentResponses,
  GetLearnSessionGroupDetailData,
  GetLearnSessionGroupDetailErrors,
  GetLearnSessionGroupDetailResponses,
  GetLearnSessionGroupsData,
  GetLearnSessionGroupsResponses,
  GetLearnSessionsData,
  GetLearnSessionsErrors,
  GetLearnSessionsResponses,
  GetLibraryBookData,
  GetLibraryBookErrors,
  GetLibraryBookResponses,
  GetMcpAuthRequestData,
  GetMcpAuthRequestErrors,
  GetMcpAuthRequestResponses,
  GetMeetingPublicPublicMeetingPublicIdGetData,
  GetMeetingPublicPublicMeetingPublicIdGetErrors,
  GetMeetingPublicPublicMeetingPublicIdGetResponses,
  GetMemberInvitationData,
  GetMemberInvitationErrors,
  GetMemberInvitationResponses,
  GetMyEnrollmentsData,
  GetMyEnrollmentsErrors,
  GetMyEnrollmentsResponses,
  GetMyGamificationData,
  GetMyGamificationErrors,
  GetMyGamificationResponses,
  GetMySessionResultData,
  GetMySessionResultErrors,
  GetMySessionResultResponses,
  GetOpenSessionsRoomsOpenSessionsGetData,
  GetOpenSessionsRoomsOpenSessionsGetErrors,
  GetOpenSessionsRoomsOpenSessionsGetResponses,
  GetPopularLearnSessionsData,
  GetPopularLearnSessionsResponses,
  GetPublicKnowledgeByTemplateData,
  GetPublicKnowledgeByTemplateErrors,
  GetPublicKnowledgeByTemplateResponses,
  GetPublicSessionGroupData,
  GetPublicSessionGroupErrors,
  GetPublicSessionGroupResponses,
  GetPublicTemplateData,
  GetPublicTemplateErrors,
  GetPublicTemplateResponses,
  GetReviewGenerationData,
  GetReviewGenerationErrors,
  GetReviewGenerationResponses,
  GetReviewSessionData,
  GetReviewSessionErrors,
  GetReviewSessionResponses,
  GetReviewStudioAccessData,
  GetReviewStudioAccessErrors,
  GetReviewStudioAccessResponses,
  GetScheduledSessionPublicPublicSessionsScheduledUrlTokenGetData,
  GetScheduledSessionPublicPublicSessionsScheduledUrlTokenGetErrors,
  GetScheduledSessionPublicPublicSessionsScheduledUrlTokenGetResponses,
  GetServerTimeData,
  GetServerTimeErrors,
  GetServerTimeResponses,
  GetSessionContentData,
  GetSessionContentErrors,
  GetSessionContentResponses,
  GetSessionGroupData,
  GetSessionGroupErrors,
  GetSessionGroupResponses,
  GetSessionInfoPublicPublicSessionsRoomIdInfoGetData,
  GetSessionInfoPublicPublicSessionsRoomIdInfoGetErrors,
  GetSessionInfoPublicPublicSessionsRoomIdInfoGetResponses,
  GetStagesData,
  GetStagesErrors,
  GetStagesResponses,
  GetTemplateSharingStatusTemplatesTemplateIdShareGetData,
  GetTemplateSharingStatusTemplatesTemplateIdShareGetErrors,
  GetTemplateSharingStatusTemplatesTemplateIdShareGetResponses,
  GetTemplatesTemplatesGetData,
  GetTemplatesTemplatesGetErrors,
  GetTemplatesTemplatesGetResponses,
  GetTemplateTemplatesTemplateIdGetData,
  GetTemplateTemplatesTemplateIdGetErrors,
  GetTemplateTemplatesTemplateIdGetResponses,
  GetTemplateTitlesPublicTitlesGetData,
  GetTemplateTitlesPublicTitlesGetErrors,
  GetTemplateTitlesPublicTitlesGetResponses,
  GetTtsModelsTtsVoicesModelsGetData,
  GetTtsModelsTtsVoicesModelsGetErrors,
  GetTtsModelsTtsVoicesModelsGetResponses,
  GetTtsProvidersTtsVoicesProvidersGetData,
  GetTtsProvidersTtsVoicesProvidersGetErrors,
  GetTtsProvidersTtsVoicesProvidersGetResponses,
  GetTtsVoicesTtsVoicesGetData,
  GetTtsVoicesTtsVoicesGetErrors,
  GetTtsVoicesTtsVoicesGetResponses,
  GetUserDataSummaryByEmailGdprDataSummaryEmailGetData,
  GetUserDataSummaryByEmailGdprDataSummaryEmailGetErrors,
  GetUserDataSummaryByEmailGdprDataSummaryEmailGetResponses,
  GetUserDataSummaryGdprDataSummaryGetData,
  GetUserDataSummaryGdprDataSummaryGetErrors,
  GetUserDataSummaryGdprDataSummaryGetResponses,
  GetUserUsersAuthGetData,
  GetUserUsersAuthGetErrors,
  GetUserUsersAuthGetResponses,
  GetVisualizationVideoUrlData,
  GetVisualizationVideoUrlErrors,
  GetVisualizationVideoUrlResponses,
  ImportCandidatesSessionsTemplateIdImportPostData,
  ImportCandidatesSessionsTemplateIdImportPostErrors,
  ImportCandidatesSessionsTemplateIdImportPostResponses,
  ImportLearningDocumentUrlData,
  ImportLearningDocumentUrlErrors,
  ImportLearningDocumentUrlResponses,
  ImportLibraryChapterData,
  ImportLibraryChapterErrors,
  ImportLibraryChapterResponses,
  InitBotPublicPublicBotInitPostData,
  InitBotPublicPublicBotInitPostErrors,
  InitBotPublicPublicBotInitPostResponses,
  IntegrityReviewData,
  IntegrityReviewErrors,
  IntegrityReviewResponses,
  InviteImportedCandidatesData,
  InviteImportedCandidatesErrors,
  InviteImportedCandidatesResponses,
  InviteMemberMembersInvitePostData,
  InviteMemberMembersInvitePostErrors,
  InviteMemberMembersInvitePostResponses,
  LinkSessionToUserData,
  LinkSessionToUserErrors,
  LinkSessionToUserResponses,
  ListDemoVideosData,
  ListDemoVideosErrors,
  ListDemoVideosResponses,
  ListEvalExperimentsData,
  ListEvalExperimentsErrors,
  ListEvalExperimentsResponses,
  ListEvalFixturesData,
  ListEvalFixturesErrors,
  ListEvalFixturesResponses,
  ListEvalReplaysData,
  ListEvalReplaysErrors,
  ListEvalReplaysResponses,
  ListEvalRunLinesData,
  ListEvalRunLinesErrors,
  ListEvalRunLinesResponses,
  ListEvalRunsData,
  ListEvalRunsErrors,
  ListEvalRunsResponses,
  ListEvaluatorsData,
  ListEvaluatorsErrors,
  ListEvaluatorsResponses,
  ListGenerationGalleryData,
  ListGenerationGalleryErrors,
  ListGenerationGalleryResponses,
  ListLibraryBooksData,
  ListLibraryBooksErrors,
  ListLibraryBooksResponses,
  ListMcpConnectionsData,
  ListMcpConnectionsErrors,
  ListMcpConnectionsResponses,
  ListMembersMembersGetData,
  ListMembersMembersGetErrors,
  ListMembersMembersGetResponses,
  ListReviewGenerationsData,
  ListReviewGenerationsErrors,
  ListReviewGenerationsResponses,
  ListSessionGroupsData,
  ListSessionGroupsErrors,
  ListSessionGroupsResponses,
  ListVerticalPacksData,
  ListVerticalPacksErrors,
  ListVerticalPacksResponses,
  MakeCallLivekitMakeCallPostData,
  MakeCallLivekitMakeCallPostErrors,
  MakeCallLivekitMakeCallPostResponses,
  OnboardingCompletedData,
  OnboardingCompletedErrors,
  OnboardingCompletedResponses,
  OrderSessionGroupTemplatesData,
  OrderSessionGroupTemplatesErrors,
  OrderSessionGroupTemplatesResponses,
  PracticeEnsureCourseData,
  PracticeEnsureCourseErrors,
  PracticeEnsureCourseResponses,
  PracticeExplainLineData,
  PracticeExplainLineErrors,
  PracticeExplainLineResponses,
  PracticeGetCourseData,
  PracticeGetCourseErrors,
  PracticeGetCourseResponses,
  PracticeGetHistoryData,
  PracticeGetHistoryErrors,
  PracticeGetHistoryResponses,
  PracticeGetLeaderboardData,
  PracticeGetLeaderboardErrors,
  PracticeGetLeaderboardResponses,
  PracticeGetReviewData,
  PracticeGetReviewErrors,
  PracticeGetReviewResponses,
  PracticeGetStatsData,
  PracticeGetStatsErrors,
  PracticeGetStatsResponses,
  PracticeGetTranscriptData,
  PracticeGetTranscriptErrors,
  PracticeGetTranscriptResponses,
  PracticeGetWordStatusesData,
  PracticeGetWordStatusesErrors,
  PracticeGetWordStatusesResponses,
  PracticeGlossLineData,
  PracticeGlossLineErrors,
  PracticeGlossLineResponses,
  PracticeListenBeatData,
  PracticeListenBeatErrors,
  PracticeListenBeatResponses,
  PracticeListWordsData,
  PracticeListWordsErrors,
  PracticeListWordsResponses,
  PracticeRecordWordEventsData,
  PracticeRecordWordEventsErrors,
  PracticeRecordWordEventsResponses,
  PracticeSetWordStatusData,
  PracticeSetWordStatusErrors,
  PracticeSetWordStatusResponses,
  PracticeSpeakCheckData,
  PracticeSpeakCheckErrors,
  PracticeSpeakCheckResponses,
  PracticeStreamWordAudioData,
  PracticeStreamWordAudioErrors,
  PracticeStreamWordAudioResponses,
  PracticeSynthesizeWordData,
  PracticeSynthesizeWordErrors,
  PracticeSynthesizeWordResponses,
  PracticeTranslateLineData,
  PracticeTranslateLineErrors,
  PracticeTranslateLineResponses,
  PracticeTranslateLinesData,
  PracticeTranslateLinesErrors,
  PracticeTranslateLinesResponses,
  PracticeUpsertWatchData,
  PracticeUpsertWatchErrors,
  PracticeUpsertWatchResponses,
  PreviewVerticalPacksData,
  PreviewVerticalPacksErrors,
  PreviewVerticalPacksResponses,
  PublishSessionGroupData,
  PublishSessionGroupErrors,
  PublishSessionGroupResponses,
  PublishTemplateTemplatesTemplateIdPublishPutData,
  PublishTemplateTemplatesTemplateIdPublishPutErrors,
  PublishTemplateTemplatesTemplateIdPublishPutResponses,
  QueueReviewVideoRetryData,
  QueueReviewVideoRetryErrors,
  QueueReviewVideoRetryResponses,
  RecordIntegrityEventsData,
  RecordIntegrityEventsErrors,
  RecordIntegrityEventsResponses,
  RenameStageData,
  RenameStageErrors,
  RenameStageResponses,
  RequestAccountDeletionGdprDeleteAccountPostData,
  RequestAccountDeletionGdprDeleteAccountPostErrors,
  RequestAccountDeletionGdprDeleteAccountPostResponses,
  RequestAccountDeletionPublicGdprDeleteAccountPublicPostData,
  RequestAccountDeletionPublicGdprDeleteAccountPublicPostErrors,
  RequestAccountDeletionPublicGdprDeleteAccountPublicPostResponses,
  RequestCallApplicationsRequestCallPostData,
  RequestCallApplicationsRequestCallPostErrors,
  RequestCallApplicationsRequestCallPostResponses,
  RequestDataExportGdprExportPostData,
  RequestDataExportGdprExportPostErrors,
  RequestDataExportGdprExportPostResponses,
  RequestDataExportPublicGdprExportPublicPostData,
  RequestDataExportPublicGdprExportPublicPostErrors,
  RequestDataExportPublicGdprExportPublicPostResponses,
  RequestLeavePublicRequestLeavePostData,
  RequestLeavePublicRequestLeavePostErrors,
  RequestLeavePublicRequestLeavePostResponses,
  RetryReviewGenerationArtifactData,
  RetryReviewGenerationArtifactErrors,
  RetryReviewGenerationArtifactResponses,
  RevokeInvitationMembersRevokePostData,
  RevokeInvitationMembersRevokePostErrors,
  RevokeInvitationMembersRevokePostResponses,
  RevokeMcpConnectionData,
  RevokeMcpConnectionErrors,
  RevokeMcpConnectionResponses,
  ScheduleInterviewPublicScheduleInterviewPostData,
  ScheduleInterviewPublicScheduleInterviewPostErrors,
  ScheduleInterviewPublicScheduleInterviewPostResponses,
  SearchReviewSessionsData,
  SearchReviewSessionsErrors,
  SearchReviewSessionsResponses,
  SendFeedbackUsersFeedbackPostData,
  SendFeedbackUsersFeedbackPostErrors,
  SendFeedbackUsersFeedbackPostResponses,
  SendPasswordResetData,
  SendPasswordResetErrors,
  SendPasswordResetResponses,
  SendRatingUsersRatingPostData,
  SendRatingUsersRatingPostErrors,
  SendRatingUsersRatingPostResponses,
  SendVerificationEmailData,
  SendVerificationEmailErrors,
  SendVerificationEmailResponses,
  SetEvalBaselineData,
  SetEvalBaselineErrors,
  SetEvalBaselineResponses,
  SetEvaluatorVersionData,
  SetEvaluatorVersionErrors,
  SetEvaluatorVersionResponses,
  SignedRecordingPublicPublicRecordingsSignedRecordingRoomIdGetData,
  SignedRecordingPublicPublicRecordingsSignedRecordingRoomIdGetErrors,
  SignedRecordingPublicPublicRecordingsSignedRecordingRoomIdGetResponses,
  SignedRecordingRecordingsSignedRecordingRoomIdGetData,
  SignedRecordingRecordingsSignedRecordingRoomIdGetErrors,
  SignedRecordingRecordingsSignedRecordingRoomIdGetResponses,
  ToggleLearningPathVisibilityData,
  ToggleLearningPathVisibilityErrors,
  ToggleLearningPathVisibilityResponses,
  TrackUnlockData,
  TrackUnlockErrors,
  TrackUnlockResponses,
  TranscodeYoutubeTaskPublicKnowledgeTranscodeYoutubePostData,
  TranscodeYoutubeTaskPublicKnowledgeTranscodeYoutubePostErrors,
  TranscodeYoutubeTaskPublicKnowledgeTranscodeYoutubePostResponses,
  TranscribeYoutubeTaskPublicKnowledgeTranscribeYoutubePostData,
  TranscribeYoutubeTaskPublicKnowledgeTranscribeYoutubePostErrors,
  TranscribeYoutubeTaskPublicKnowledgeTranscribeYoutubePostResponses,
  TriggerDeletionProcessingData,
  TriggerDeletionProcessingErrors,
  TriggerDeletionProcessingResponses,
  TriggerExportProcessingData,
  TriggerExportProcessingErrors,
  TriggerExportProcessingResponses,
  TriggerRetentionCleanupData,
  TriggerRetentionCleanupErrors,
  TriggerRetentionCleanupResponses,
  UnpublishSessionGroupData,
  UnpublishSessionGroupErrors,
  UnpublishSessionGroupResponses,
  UpdateApplicationStageApplicationsUpdateStagePostData,
  UpdateApplicationStageApplicationsUpdateStagePostErrors,
  UpdateApplicationStageApplicationsUpdateStagePostResponses,
  UpdateCompanyCompaniesUpdatePutData,
  UpdateCompanyCompaniesUpdatePutErrors,
  UpdateCompanyCompaniesUpdatePutResponses,
  UpdateEvalFixtureData,
  UpdateEvalFixtureErrors,
  UpdateEvalFixtureResponses,
  UpdateEvaluatorData,
  UpdateEvaluatorErrors,
  UpdateEvaluatorResponses,
  UpdateRoleMembersRolePostData,
  UpdateRoleMembersRolePostErrors,
  UpdateRoleMembersRolePostResponses,
  UpdateSessionGroupData,
  UpdateSessionGroupErrors,
  UpdateSessionGroupResponses,
  UpdateTemplateTemplatesTemplateIdPutData,
  UpdateTemplateTemplatesTemplateIdPutErrors,
  UpdateTemplateTemplatesTemplateIdPutResponses,
  UploadImageKnowledgeData,
  UploadImageKnowledgeErrors,
  UploadImageKnowledgeResponses,
  UploadLearningDocumentData,
  UploadLearningDocumentErrors,
  UploadLearningDocumentResponses,
  UploadLearningPathCoverImageData,
  UploadLearningPathCoverImageErrors,
  UploadLearningPathCoverImageResponses,
  UploadListeningKnowledgeData,
  UploadListeningKnowledgeErrors,
  UploadListeningKnowledgeResponses,
  UploadMp4KnowledgeData,
  UploadMp4KnowledgeErrors,
  UploadMp4KnowledgeResponses,
  UploadPdfKnowledgeData,
  UploadPdfKnowledgeErrors,
  UploadPdfKnowledgeResponses,
  UploadYoutubeKnowledgeData,
  UploadYoutubeKnowledgeErrors,
  UploadYoutubeKnowledgeResponses,
  UpsertReviewGenerationReviewData,
  UpsertReviewGenerationReviewErrors,
  UpsertReviewGenerationReviewResponses,
  UpsertReviewSessionAnnotationData,
  UpsertReviewSessionAnnotationErrors,
  UpsertReviewSessionAnnotationResponses,
  ValidateFieldPublicPublicUsersIsValidFieldGetData,
  ValidateFieldPublicPublicUsersIsValidFieldGetErrors,
  ValidateFieldPublicPublicUsersIsValidFieldGetResponses,
  WebLivekitWebhookPostData,
  WebLivekitWebhookPostErrors,
  WebLivekitWebhookPostResponses,
} from './types.gen';

export type Options<
  TData extends TDataShape = TDataShape,
  ThrowOnError extends boolean = boolean,
> = Options2<TData, ThrowOnError> & {
  /**
   * You can provide a client instance returned by `createClient()` instead of
   * individual options. This might be also useful if you want to implement a
   * custom client.
   */
  client?: Client;
  /**
   * You can pass arbitrary values through the `meta` object. This can be
   * used to access values that aren't defined as part of the SDK function.
   */
  meta?: Record<string, unknown>;
};

/**
 * Get
 */
export const getHealthGet = <ThrowOnError extends boolean = false>(
  options?: Options<GetHealthGetData, ThrowOnError>,
) => {
  return (options?.client ?? client).get<
    GetHealthGetResponses,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/_health',
    ...options,
  });
};

/**
 * Get Server Time
 *
 * Returns the current server UTC time for client-side clock sync
 */
export const getServerTime = <ThrowOnError extends boolean = false>(
  options?: Options<GetServerTimeData, ThrowOnError>,
) => {
  return (options?.client ?? client).get<
    GetServerTimeResponses,
    GetServerTimeErrors,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/public/server-time',
    ...options,
  });
};

/**
 * Get Visualization Video Url
 *
 * Return signed video/poster URLs plus segment timings of a video story knowledge item.
 */
export const getVisualizationVideoUrl = <ThrowOnError extends boolean = false>(
  options: Options<GetVisualizationVideoUrlData, ThrowOnError>,
) => {
  return (options.client ?? client).get<
    GetVisualizationVideoUrlResponses,
    GetVisualizationVideoUrlErrors,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/public/visualization/{knowledge_item_id}/video-url',
    ...options,
  });
};

/**
 * Get Meeting Public
 *
 * Public endpoint to get meeting information by public ID
 */
export const getMeetingPublicPublicMeetingPublicIdGet = <
  ThrowOnError extends boolean = false,
>(
  options: Options<GetMeetingPublicPublicMeetingPublicIdGetData, ThrowOnError>,
) => {
  return (options.client ?? client).get<
    GetMeetingPublicPublicMeetingPublicIdGetResponses,
    GetMeetingPublicPublicMeetingPublicIdGetErrors,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/public/meeting/{public_id}',
    ...options,
  });
};

/**
 * Get Public Template
 */
export const getPublicTemplate = <ThrowOnError extends boolean = false>(
  options: Options<GetPublicTemplateData, ThrowOnError>,
) => {
  return (options.client ?? client).get<
    GetPublicTemplateResponses,
    GetPublicTemplateErrors,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/public/templates/{public_id}/public',
    ...options,
  });
};

/**
 * Get Candidate Public
 *
 * Public endpoint to get a single candidate by application ID
 */
export const getCandidatePublicPublicCandidatesApplicationIdGet = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    GetCandidatePublicPublicCandidatesApplicationIdGetData,
    ThrowOnError
  >,
) => {
  return (options.client ?? client).get<
    GetCandidatePublicPublicCandidatesApplicationIdGetResponses,
    GetCandidatePublicPublicCandidatesApplicationIdGetErrors,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/public/candidates/{application_id}',
    ...options,
  });
};

/**
 * Get Candidate Learn Recommendations
 *
 * Generate AI-based learning recommendations from a candidate's assessment results.
 */
export const getCandidateLearnRecommendations = <
  ThrowOnError extends boolean = false,
>(
  options: Options<GetCandidateLearnRecommendationsData, ThrowOnError>,
) => {
  return (options.client ?? client).get<
    GetCandidateLearnRecommendationsResponses,
    GetCandidateLearnRecommendationsErrors,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/public/candidates/{application_id}/learn-recommendations',
    ...options,
  });
};

/**
 * Check Domain Public
 *
 * Public endpoint to check if domain is available
 */
export const checkDomainPublicPublicCompaniesDomainCheckPublicIdGet = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    CheckDomainPublicPublicCompaniesDomainCheckPublicIdGetData,
    ThrowOnError
  >,
) => {
  return (options.client ?? client).get<
    CheckDomainPublicPublicCompaniesDomainCheckPublicIdGetResponses,
    CheckDomainPublicPublicCompaniesDomainCheckPublicIdGetErrors,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/public/companies/domain_check/{public_id}',
    ...options,
  });
};

/**
 * Validate Field Public
 *
 * Public endpoint to validate user fields like email
 */
export const validateFieldPublicPublicUsersIsValidFieldGet = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    ValidateFieldPublicPublicUsersIsValidFieldGetData,
    ThrowOnError
  >,
) => {
  return (options.client ?? client).get<
    ValidateFieldPublicPublicUsersIsValidFieldGetResponses,
    ValidateFieldPublicPublicUsersIsValidFieldGetErrors,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/public/users/is_valid_field',
    ...options,
  });
};

/**
 * Send Password Reset
 */
export const sendPasswordReset = <ThrowOnError extends boolean = false>(
  options: Options<SendPasswordResetData, ThrowOnError>,
) => {
  return (options.client ?? client).post<
    SendPasswordResetResponses,
    SendPasswordResetErrors,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/public/users/send-password-reset',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });
};

/**
 * Get Session Info Public
 *
 * Public endpoint to get session information
 */
export const getSessionInfoPublicPublicSessionsRoomIdInfoGet = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    GetSessionInfoPublicPublicSessionsRoomIdInfoGetData,
    ThrowOnError
  >,
) => {
  return (options.client ?? client).get<
    GetSessionInfoPublicPublicSessionsRoomIdInfoGetResponses,
    GetSessionInfoPublicPublicSessionsRoomIdInfoGetErrors,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/public/sessions/{room_id}/info',
    ...options,
  });
};

/**
 * Record Integrity Events
 *
 * The session page reports tab switches and copy/paste attempts while the session runs.
 */
export const recordIntegrityEvents = <ThrowOnError extends boolean = false>(
  options: Options<RecordIntegrityEventsData, ThrowOnError>,
) => {
  return (options.client ?? client).post<
    RecordIntegrityEventsResponses,
    RecordIntegrityEventsErrors,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/public/sessions/{room_id}/integrity-events',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });
};

/**
 * Get Session Content Public
 *
 * Public endpoint to get session content (carousel slides, interactive elements) for a room.
 */
export const getSessionContent = <ThrowOnError extends boolean = false>(
  options: Options<GetSessionContentData, ThrowOnError>,
) => {
  return (options.client ?? client).get<
    GetSessionContentResponses,
    GetSessionContentErrors,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/public/sessions/{room_id}/content',
    ...options,
  });
};

/**
 * Get Scheduled Session Public
 *
 * Public endpoint to get scheduled session invitation details by URL token
 */
export const getScheduledSessionPublicPublicSessionsScheduledUrlTokenGet = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    GetScheduledSessionPublicPublicSessionsScheduledUrlTokenGetData,
    ThrowOnError
  >,
) => {
  return (options.client ?? client).get<
    GetScheduledSessionPublicPublicSessionsScheduledUrlTokenGetResponses,
    GetScheduledSessionPublicPublicSessionsScheduledUrlTokenGetErrors,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/public/sessions/scheduled/{url_token}',
    ...options,
  });
};

/**
 * Get Availability Public
 *
 * Public endpoint to get available time slots for a given date and duration
 */
export const getAvailabilityPublicPublicSessionsAvailabilityGet = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    GetAvailabilityPublicPublicSessionsAvailabilityGetData,
    ThrowOnError
  >,
) => {
  return (options.client ?? client).get<
    GetAvailabilityPublicPublicSessionsAvailabilityGetResponses,
    GetAvailabilityPublicPublicSessionsAvailabilityGetErrors,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/public/sessions/availability',
    ...options,
  });
};

/**
 * Init Bot Public
 *
 * Public endpoint to initialize bot
 */
export const initBotPublicPublicBotInitPost = <
  ThrowOnError extends boolean = false,
>(
  options: Options<InitBotPublicPublicBotInitPostData, ThrowOnError>,
) => {
  return (options.client ?? client).post<
    InitBotPublicPublicBotInitPostResponses,
    InitBotPublicPublicBotInitPostErrors,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/public/bot/init',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });
};

/**
 * Signed Recording Public
 *
 * Public endpoint to get signed recording URL when template is shared
 */
export const signedRecordingPublicPublicRecordingsSignedRecordingRoomIdGet = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    SignedRecordingPublicPublicRecordingsSignedRecordingRoomIdGetData,
    ThrowOnError
  >,
) => {
  return (options.client ?? client).get<
    SignedRecordingPublicPublicRecordingsSignedRecordingRoomIdGetResponses,
    SignedRecordingPublicPublicRecordingsSignedRecordingRoomIdGetErrors,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/public/recordings/signed-recording/{room_id}',
    ...options,
  });
};

/**
 * Get Conversation Transcription Public
 *
 * Public endpoint to get transcription in conversation format when template is shared
 */
export const getConversationTranscriptionPublicPublicRecordingsConversationTranscriptionIdGet =
  <ThrowOnError extends boolean = false>(
    options: Options<
      GetConversationTranscriptionPublicPublicRecordingsConversationTranscriptionIdGetData,
      ThrowOnError
    >,
  ) => {
    return (options.client ?? client).get<
      GetConversationTranscriptionPublicPublicRecordingsConversationTranscriptionIdGetResponses,
      GetConversationTranscriptionPublicPublicRecordingsConversationTranscriptionIdGetErrors,
      ThrowOnError
    >({
      responseType: 'json',
      url: '/public/recordings/conversation-transcription/{id}',
      ...options,
    });
  };

/**
 * Create Candidate Application Public
 *
 * Public endpoint to create candidate application
 */
export const createCandidateApplicationPublicPublicSessionsCandidateApplicationPost =
  <ThrowOnError extends boolean = false>(
    options: Options<
      CreateCandidateApplicationPublicPublicSessionsCandidateApplicationPostData,
      ThrowOnError
    >,
  ) => {
    return (options.client ?? client).post<
      CreateCandidateApplicationPublicPublicSessionsCandidateApplicationPostResponses,
      CreateCandidateApplicationPublicPublicSessionsCandidateApplicationPostErrors,
      ThrowOnError
    >({
      responseType: 'json',
      url: '/public/sessions/candidate-application',
      ...options,
      headers: {
        'Content-Type': 'application/json',
        ...options.headers,
      },
    });
  };

/**
 * Schedule Interview
 *
 * Schedule an interview for a specific time slot
 */
export const scheduleInterviewPublicScheduleInterviewPost = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    ScheduleInterviewPublicScheduleInterviewPostData,
    ThrowOnError
  >,
) => {
  return (options.client ?? client).post<
    ScheduleInterviewPublicScheduleInterviewPostResponses,
    ScheduleInterviewPublicScheduleInterviewPostErrors,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/public/schedule-interview',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });
};

/**
 * Cancel Interview Public
 *
 * The candidate cancels their booked interview from the schedule page (the invite token is the secret).
 */
export const cancelInterviewPublic = <ThrowOnError extends boolean = false>(
  options: Options<CancelInterviewPublicData, ThrowOnError>,
) => {
  return (options.client ?? client).post<
    CancelInterviewPublicResponses,
    CancelInterviewPublicErrors,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/public/sessions/scheduled/{url_token}/cancel',
    ...options,
  });
};

/**
 * Apply And Start Instant
 *
 * Create candidate application and immediately start an instant session
 */
export const applyAndStartInstant = <ThrowOnError extends boolean = false>(
  options: Options<ApplyAndStartInstantData, ThrowOnError>,
) => {
  return (options.client ?? client).post<
    ApplyAndStartInstantResponses,
    ApplyAndStartInstantErrors,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/public/sessions/apply-and-start-instant',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });
};

/**
 * Transcode Youtube Task
 *
 * Cloud Tasks entrypoint. Creates a Transcoder job (if not created yet) and polls status by re-enqueueing itself.
 * Updates knowledge_base_items with HLS manifest/base URL when done.
 */
export const transcodeYoutubeTaskPublicKnowledgeTranscodeYoutubePost = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    TranscodeYoutubeTaskPublicKnowledgeTranscodeYoutubePostData,
    ThrowOnError
  >,
) => {
  return (options.client ?? client).post<
    TranscodeYoutubeTaskPublicKnowledgeTranscodeYoutubePostResponses,
    TranscodeYoutubeTaskPublicKnowledgeTranscodeYoutubePostErrors,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/public/knowledge/transcode-youtube',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });
};

/**
 * Fetch Youtube Task
 *
 * Cloud Tasks entrypoint. Downloads the YouTube MP4, uploads it to GCS, then enqueues transcode + transcription.
 *
 * This keeps the authenticated `/knowledge/youtube` endpoint fast.
 */
export const fetchYoutubeTaskPublicKnowledgeFetchYoutubePost = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    FetchYoutubeTaskPublicKnowledgeFetchYoutubePostData,
    ThrowOnError
  >,
) => {
  return (options.client ?? client).post<
    FetchYoutubeTaskPublicKnowledgeFetchYoutubePostResponses,
    FetchYoutubeTaskPublicKnowledgeFetchYoutubePostErrors,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/public/knowledge/fetch-youtube',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });
};

/**
 * Get Knowledge Hls Manifest
 *
 * Pasteable HLS master manifest URL for public apps/players.
 *
 * - The manifest is served from the recorder domain (this endpoint).
 * - Every referenced URI inside the manifest is rewritten to a short-lived GCS signed URL.
 */
export const getKnowledgeHlsManifest = <ThrowOnError extends boolean = false>(
  options: Options<GetKnowledgeHlsManifestData, ThrowOnError>,
) => {
  return (options.client ?? client).get<
    GetKnowledgeHlsManifestResponses,
    GetKnowledgeHlsManifestErrors,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/public/knowledge/hls/manifest/{knowledge_item_id}',
    ...options,
  });
};

/**
 * Get Knowledge Hls Playlist
 *
 * Serves an HLS playlist (m3u8) from GCS, rewriting all referenced URIs to signed URLs.
 *
 * This is needed because master manifests often reference variant playlists, and those playlists
 * contain segment URIs that must also be signed when the bucket is private.
 */
export const getKnowledgeHlsPlaylist = <ThrowOnError extends boolean = false>(
  options: Options<GetKnowledgeHlsPlaylistData, ThrowOnError>,
) => {
  return (options.client ?? client).get<
    GetKnowledgeHlsPlaylistResponses,
    GetKnowledgeHlsPlaylistErrors,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/public/knowledge/hls/playlist/{knowledge_item_id}/{playlist_path}',
    ...options,
  });
};

/**
 * Get Knowledge Material Signed Url
 *
 * Returns a short-lived signed URL for a knowledge "material" upload (PDF/PPT/DOC).
 *
 * The bucket is expected to be private; do NOT use stored public GCS URLs for downloads.
 */
export const getKnowledgeMaterialSignedUrl = <
  ThrowOnError extends boolean = false,
>(
  options: Options<GetKnowledgeMaterialSignedUrlData, ThrowOnError>,
) => {
  return (options.client ?? client).get<
    GetKnowledgeMaterialSignedUrlResponses,
    GetKnowledgeMaterialSignedUrlErrors,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/public/knowledge/material/signed/{knowledge_item_id}',
    ...options,
  });
};

/**
 * Get Public Knowledge By Template
 *
 * Public endpoint to list knowledge materials for a session template.
 * Used on the learning path share page.
 */
export const getPublicKnowledgeByTemplate = <
  ThrowOnError extends boolean = false,
>(
  options: Options<GetPublicKnowledgeByTemplateData, ThrowOnError>,
) => {
  return (options.client ?? client).get<
    GetPublicKnowledgeByTemplateResponses,
    GetPublicKnowledgeByTemplateErrors,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/public/knowledge/by-template/{template_id}',
    ...options,
  });
};

/**
 * Transcribe Youtube Task
 *
 * Cloud Tasks entrypoint. Calls Gemini on the uploaded MP4 (GCS) and stores a timestamped transcription/event list.
 * Creates a separate knowledge_base_item with type=transcription and links it from the video knowledge item.
 */
export const transcribeYoutubeTaskPublicKnowledgeTranscribeYoutubePost = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    TranscribeYoutubeTaskPublicKnowledgeTranscribeYoutubePostData,
    ThrowOnError
  >,
) => {
  return (options.client ?? client).post<
    TranscribeYoutubeTaskPublicKnowledgeTranscribeYoutubePostResponses,
    TranscribeYoutubeTaskPublicKnowledgeTranscribeYoutubePostErrors,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/public/knowledge/transcribe-youtube',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });
};

/**
 * Extract Material Task
 *
 * Cloud Tasks entrypoint. Calls Gemini on an uploaded material file (PDF/PPT/PPTX/DOC/DOCX)
 * using its GCS URI and stores extracted text into knowledge_base_items.data.content.
 *
 * This text is later passed as full context to the presentation agent.
 */
export const extractMaterialTaskPublicKnowledgeExtractMaterialPost = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    ExtractMaterialTaskPublicKnowledgeExtractMaterialPostData,
    ThrowOnError
  >,
) => {
  return (options.client ?? client).post<
    ExtractMaterialTaskPublicKnowledgeExtractMaterialPostResponses,
    ExtractMaterialTaskPublicKnowledgeExtractMaterialPostErrors,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/public/knowledge/extract-material',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });
};

/**
 * Extract Listening Task
 *
 * Cloud Tasks entrypoint: read a listening exercise's questions, answers and transcript (api.knowledge.listening).
 */
export const extractListeningTaskPublicKnowledgeExtractListeningPost = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    ExtractListeningTaskPublicKnowledgeExtractListeningPostData,
    ThrowOnError
  >,
) => {
  return (options.client ?? client).post<
    ExtractListeningTaskPublicKnowledgeExtractListeningPostResponses,
    ExtractListeningTaskPublicKnowledgeExtractListeningPostErrors,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/public/knowledge/extract-listening',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });
};

/**
 * Describe Image Task
 *
 * Cloud Tasks entrypoint. Calls Gemini vision on an uploaded image to generate a detailed
 * description, then stores it in knowledge_base_items.data.content and data.description.
 *
 * This description is later included in the agent's system prompt so it knows what each image
 * contains and can intelligently choose which image to show.
 */
export const describeImageTaskPublicKnowledgeDescribeImagePost = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    DescribeImageTaskPublicKnowledgeDescribeImagePostData,
    ThrowOnError
  >,
) => {
  return (options.client ?? client).post<
    DescribeImageTaskPublicKnowledgeDescribeImagePostResponses,
    DescribeImageTaskPublicKnowledgeDescribeImagePostErrors,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/public/knowledge/describe-image',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });
};

/**
 * Request Leave
 */
export const requestLeavePublicRequestLeavePost = <
  ThrowOnError extends boolean = false,
>(
  options: Options<RequestLeavePublicRequestLeavePostData, ThrowOnError>,
) => {
  return (options.client ?? client).post<
    RequestLeavePublicRequestLeavePostResponses,
    RequestLeavePublicRequestLeavePostErrors,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/public/request-leave',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });
};

/**
 * Generate Session By Template
 */
export const generateSessionByTemplatePublicGenerateSessionByTemplatePost = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    GenerateSessionByTemplatePublicGenerateSessionByTemplatePostData,
    ThrowOnError
  >,
) => {
  return (options.client ?? client).post<
    GenerateSessionByTemplatePublicGenerateSessionByTemplatePostResponses,
    GenerateSessionByTemplatePublicGenerateSessionByTemplatePostErrors,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/public/generate-session-by-template',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });
};

/**
 * Get Candidates Public
 */
export const getCandidatesPublicPublicCandidatesGet = <
  ThrowOnError extends boolean = false,
>(
  options?: Options<GetCandidatesPublicPublicCandidatesGetData, ThrowOnError>,
) => {
  return (options?.client ?? client).get<
    GetCandidatesPublicPublicCandidatesGetResponses,
    GetCandidatesPublicPublicCandidatesGetErrors,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/public/candidates',
    ...options,
  });
};

/**
 * Get Invitation
 */
export const getMemberInvitation = <ThrowOnError extends boolean = false>(
  options: Options<GetMemberInvitationData, ThrowOnError>,
) => {
  return (options.client ?? client).get<
    GetMemberInvitationResponses,
    GetMemberInvitationErrors,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/public/invitation',
    ...options,
  });
};

/**
 * Check Email Exists
 */
export const checkEmailExists = <ThrowOnError extends boolean = false>(
  options: Options<CheckEmailExistsData, ThrowOnError>,
) => {
  return (options.client ?? client).get<
    CheckEmailExistsResponses,
    CheckEmailExistsErrors,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/public/check-email',
    ...options,
  });
};

/**
 * Create With Company
 */
export const createUserWithCompany = <ThrowOnError extends boolean = false>(
  options: Options<CreateUserWithCompanyData, ThrowOnError>,
) => {
  return (options.client ?? client).post<
    CreateUserWithCompanyResponses,
    CreateUserWithCompanyErrors,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/public/users/with-company',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });
};

/**
 * Decline Invitation
 */
export const declineInvitation = <ThrowOnError extends boolean = false>(
  options: Options<DeclineInvitationData, ThrowOnError>,
) => {
  return (options.client ?? client).post<
    DeclineInvitationResponses,
    DeclineInvitationErrors,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/public/decline',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });
};

/**
 * Accept Invitation
 */
export const acceptInvitation = <ThrowOnError extends boolean = false>(
  options: Options<AcceptInvitationData, ThrowOnError>,
) => {
  return (options.client ?? client).post<
    AcceptInvitationResponses,
    AcceptInvitationErrors,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/public/accept',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });
};

/**
 * Get Template Titles
 */
export const getTemplateTitlesPublicTitlesGet = <
  ThrowOnError extends boolean = false,
>(
  options?: Options<GetTemplateTitlesPublicTitlesGetData, ThrowOnError>,
) => {
  return (options?.client ?? client).get<
    GetTemplateTitlesPublicTitlesGetResponses,
    GetTemplateTitlesPublicTitlesGetErrors,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/public/titles',
    ...options,
  });
};

/**
 * Track Unlock
 */
export const trackUnlock = <ThrowOnError extends boolean = false>(
  options: Options<TrackUnlockData, ThrowOnError>,
) => {
  return (options.client ?? client).post<
    TrackUnlockResponses,
    TrackUnlockErrors,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/public/track-unlock',
    ...options,
  });
};

/**
 * Signed Recording
 */
export const signedRecordingRecordingsSignedRecordingRoomIdGet = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    SignedRecordingRecordingsSignedRecordingRoomIdGetData,
    ThrowOnError
  >,
) => {
  return (options.client ?? client).get<
    SignedRecordingRecordingsSignedRecordingRoomIdGetResponses,
    SignedRecordingRecordingsSignedRecordingRoomIdGetErrors,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/recordings/signed-recording/{room_id}',
    ...options,
  });
};

/**
 * Delete Recording
 */
export const deleteRecordingRecordingsRecordingRoomIdDelete = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    DeleteRecordingRecordingsRecordingRoomIdDeleteData,
    ThrowOnError
  >,
) => {
  return (options.client ?? client).delete<
    DeleteRecordingRecordingsRecordingRoomIdDeleteResponses,
    DeleteRecordingRecordingsRecordingRoomIdDeleteErrors,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/recordings/recording/{room_id}',
    ...options,
  });
};

/**
 * Get Conversation Transcription
 *
 * Get transcription in conversation format.
 */
export const getConversationTranscriptionRecordingsConversationTranscriptionIdGet =
  <ThrowOnError extends boolean = false>(
    options: Options<
      GetConversationTranscriptionRecordingsConversationTranscriptionIdGetData,
      ThrowOnError
    >,
  ) => {
    return (options.client ?? client).get<
      GetConversationTranscriptionRecordingsConversationTranscriptionIdGetResponses,
      GetConversationTranscriptionRecordingsConversationTranscriptionIdGetErrors,
      ThrowOnError
    >({
      responseType: 'json',
      url: '/recordings/conversation-transcription/{id}',
      ...options,
    });
  };

/**
 * Web
 */
export const webLivekitWebhookPost = <ThrowOnError extends boolean = false>(
  options?: Options<WebLivekitWebhookPostData, ThrowOnError>,
) => {
  return (options?.client ?? client).post<
    WebLivekitWebhookPostResponses,
    WebLivekitWebhookPostErrors,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/livekit/webhook',
    ...options,
  });
};

/**
 * Assess Session
 */
export const assessSession = <ThrowOnError extends boolean = false>(
  options: Options<AssessSessionData, ThrowOnError>,
) => {
  return (options.client ?? client).post<
    AssessSessionResponses,
    AssessSessionErrors,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/livekit/assess-session',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });
};

/**
 * Generate Single Summary
 *
 * Cloud Tasks handler. Return 2xx for permanent failures so tasks stop retrying.
 */
export const generateSingleSummaryLivekitGenerateSingleSummaryPost = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    GenerateSingleSummaryLivekitGenerateSingleSummaryPostData,
    ThrowOnError
  >,
) => {
  return (options.client ?? client).post<
    GenerateSingleSummaryLivekitGenerateSingleSummaryPostResponses,
    GenerateSingleSummaryLivekitGenerateSingleSummaryPostErrors,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/livekit/generate-single-summary',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });
};

/**
 * Assess Recordings
 *
 * Cloud Tasks handler. Ack permanent 4xx failures so tasks stop retrying.
 */
export const assessRecordings = <ThrowOnError extends boolean = false>(
  options: Options<AssessRecordingsData, ThrowOnError>,
) => {
  return (options.client ?? client).post<
    AssessRecordingsResponses,
    AssessRecordingsErrors,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/livekit/assess-recordings',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });
};

/**
 * Check Camera
 *
 * Cloud Task: label the application with how much of its recording had the camera off.
 */
export const checkCamera = <ThrowOnError extends boolean = false>(
  options: Options<CheckCameraData, ThrowOnError>,
) => {
  return (options.client ?? client).post<
    CheckCameraResponses,
    CheckCameraErrors,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/livekit/check-camera',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });
};

/**
 * Integrity Review
 *
 * Cloud Task: score the recording on 15 integrity criteria. 2xx unless Gemini's quota is hit (then retried).
 */
export const integrityReview = <ThrowOnError extends boolean = false>(
  options: Options<IntegrityReviewData, ThrowOnError>,
) => {
  return (options.client ?? client).post<
    IntegrityReviewResponses,
    IntegrityReviewErrors,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/livekit/integrity-review',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });
};

/**
 * Assess Recordings Advanced
 */
export const assessRecordingsAdvanced = <ThrowOnError extends boolean = false>(
  options: Options<AssessRecordingsAdvancedData, ThrowOnError>,
) => {
  return (options.client ?? client).post<
    AssessRecordingsAdvancedResponses,
    AssessRecordingsAdvancedErrors,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/livekit/assess-recordings-advanced',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });
};

/**
 * Make Call
 */
export const makeCallLivekitMakeCallPost = <
  ThrowOnError extends boolean = false,
>(
  options: Options<MakeCallLivekitMakeCallPostData, ThrowOnError>,
) => {
  return (options.client ?? client).post<
    MakeCallLivekitMakeCallPostResponses,
    MakeCallLivekitMakeCallPostErrors,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/livekit/make-call',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });
};

/**
 * Get Tts Voices
 *
 * Get all available TTS voices from supported providers (OpenAI, ElevenLabs, Google).
 *
 * Returns unified voice information including:
 * - Voice names and IDs
 * - Preview URLs for testing voices
 * - Supported languages and locales
 * - Available models for each provider
 * - Voice metadata (gender, age, accent, etc.)
 */
export const getTtsVoicesTtsVoicesGet = <ThrowOnError extends boolean = false>(
  options?: Options<GetTtsVoicesTtsVoicesGetData, ThrowOnError>,
) => {
  return (options?.client ?? client).get<
    GetTtsVoicesTtsVoicesGetResponses,
    GetTtsVoicesTtsVoicesGetErrors,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/tts-voices/',
    ...options,
  });
};

/**
 * Get Tts Providers
 *
 * Get list of supported TTS providers
 */
export const getTtsProvidersTtsVoicesProvidersGet = <
  ThrowOnError extends boolean = false,
>(
  options?: Options<GetTtsProvidersTtsVoicesProvidersGetData, ThrowOnError>,
) => {
  return (options?.client ?? client).get<
    GetTtsProvidersTtsVoicesProvidersGetResponses,
    GetTtsProvidersTtsVoicesProvidersGetErrors,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/tts-voices/providers',
    ...options,
  });
};

/**
 * Get Tts Models
 *
 * Get available TTS models, optionally filtered by provider
 */
export const getTtsModelsTtsVoicesModelsGet = <
  ThrowOnError extends boolean = false,
>(
  options?: Options<GetTtsModelsTtsVoicesModelsGetData, ThrowOnError>,
) => {
  return (options?.client ?? client).get<
    GetTtsModelsTtsVoicesModelsGetResponses,
    GetTtsModelsTtsVoicesModelsGetErrors,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/tts-voices/models',
    ...options,
  });
};

/**
 * Send Feedback
 */
export const sendFeedbackUsersFeedbackPost = <
  ThrowOnError extends boolean = false,
>(
  options: Options<SendFeedbackUsersFeedbackPostData, ThrowOnError>,
) => {
  return (options.client ?? client).post<
    SendFeedbackUsersFeedbackPostResponses,
    SendFeedbackUsersFeedbackPostErrors,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/users/feedback',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });
};

/**
 * Send Rating
 */
export const sendRatingUsersRatingPost = <ThrowOnError extends boolean = false>(
  options: Options<SendRatingUsersRatingPostData, ThrowOnError>,
) => {
  return (options.client ?? client).post<
    SendRatingUsersRatingPostResponses,
    SendRatingUsersRatingPostErrors,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/users/rating',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });
};

/**
 * Get User
 */
export const getUserUsersAuthGet = <ThrowOnError extends boolean = false>(
  options?: Options<GetUserUsersAuthGetData, ThrowOnError>,
) => {
  return (options?.client ?? client).get<
    GetUserUsersAuthGetResponses,
    GetUserUsersAuthGetErrors,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/users/auth',
    ...options,
  });
};

/**
 * Generate Api Key Endpoint
 *
 * Generate a JWT API key for the company
 *
 * This endpoint generates a signed JWT token that can be used for
 * integrations like Softgarden. The token includes the company_id
 * and is signed with the configured secret.
 */
export const generateApiKeyEndpointUsersGenerateKeyPost = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    GenerateApiKeyEndpointUsersGenerateKeyPostData,
    ThrowOnError
  >,
) => {
  return (options.client ?? client).post<
    GenerateApiKeyEndpointUsersGenerateKeyPostResponses,
    GenerateApiKeyEndpointUsersGenerateKeyPostErrors,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/users/generate-key',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });
};

/**
 * Onboarding Completed
 */
export const onboardingCompleted = <ThrowOnError extends boolean = false>(
  options?: Options<OnboardingCompletedData, ThrowOnError>,
) => {
  return (options?.client ?? client).post<
    OnboardingCompletedResponses,
    OnboardingCompletedErrors,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/users/onboarding-completed',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options?.headers,
    },
  });
};

/**
 * Send Verification Email
 */
export const sendVerificationEmail = <ThrowOnError extends boolean = false>(
  options?: Options<SendVerificationEmailData, ThrowOnError>,
) => {
  return (options?.client ?? client).post<
    SendVerificationEmailResponses,
    SendVerificationEmailErrors,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/users/send-verification-email',
    ...options,
  });
};

/**
 * Add Account Type
 */
export const addAccountType = <ThrowOnError extends boolean = false>(
  options: Options<AddAccountTypeData, ThrowOnError>,
) => {
  return (options.client ?? client).post<
    AddAccountTypeResponses,
    AddAccountTypeErrors,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/users/add-account-type',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });
};

/**
 * Update Company
 */
export const updateCompanyCompaniesUpdatePut = <
  ThrowOnError extends boolean = false,
>(
  options: Options<UpdateCompanyCompaniesUpdatePutData, ThrowOnError>,
) => {
  return (options.client ?? client).put<
    UpdateCompanyCompaniesUpdatePutResponses,
    UpdateCompanyCompaniesUpdatePutErrors,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/companies/update',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });
};

/**
 * Get Company
 */
export const getCompanyCompaniesSingleGet = <
  ThrowOnError extends boolean = false,
>(
  options?: Options<GetCompanyCompaniesSingleGetData, ThrowOnError>,
) => {
  return (options?.client ?? client).get<
    GetCompanyCompaniesSingleGetResponses,
    GetCompanyCompaniesSingleGetErrors,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/companies/single',
    ...options,
  });
};

/**
 * Get Templates
 */
export const getTemplatesTemplatesGet = <ThrowOnError extends boolean = false>(
  options?: Options<GetTemplatesTemplatesGetData, ThrowOnError>,
) => {
  return (options?.client ?? client).get<
    GetTemplatesTemplatesGetResponses,
    GetTemplatesTemplatesGetErrors,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/templates',
    ...options,
  });
};

/**
 * Create Template
 */
export const createTemplateTemplatesPost = <
  ThrowOnError extends boolean = false,
>(
  options: Options<CreateTemplateTemplatesPostData, ThrowOnError>,
) => {
  return (options.client ?? client).post<
    CreateTemplateTemplatesPostResponses,
    CreateTemplateTemplatesPostErrors,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/templates',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });
};

/**
 * Delete Template
 */
export const deleteTemplateTemplatesTemplateIdDelete = <
  ThrowOnError extends boolean = false,
>(
  options: Options<DeleteTemplateTemplatesTemplateIdDeleteData, ThrowOnError>,
) => {
  return (options.client ?? client).delete<
    DeleteTemplateTemplatesTemplateIdDeleteResponses,
    DeleteTemplateTemplatesTemplateIdDeleteErrors,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/templates/{template_id}',
    ...options,
  });
};

/**
 * Get Template
 */
export const getTemplateTemplatesTemplateIdGet = <
  ThrowOnError extends boolean = false,
>(
  options: Options<GetTemplateTemplatesTemplateIdGetData, ThrowOnError>,
) => {
  return (options.client ?? client).get<
    GetTemplateTemplatesTemplateIdGetResponses,
    GetTemplateTemplatesTemplateIdGetErrors,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/templates/{template_id}',
    ...options,
  });
};

/**
 * Update Template
 */
export const updateTemplateTemplatesTemplateIdPut = <
  ThrowOnError extends boolean = false,
>(
  options: Options<UpdateTemplateTemplatesTemplateIdPutData, ThrowOnError>,
) => {
  return (options.client ?? client).put<
    UpdateTemplateTemplatesTemplateIdPutResponses,
    UpdateTemplateTemplatesTemplateIdPutErrors,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/templates/{template_id}',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });
};

/**
 * Publish Template
 *
 * Publish template by moving draft_mind_config to mind_config and updating last_published_at
 */
export const publishTemplateTemplatesTemplateIdPublishPut = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    PublishTemplateTemplatesTemplateIdPublishPutData,
    ThrowOnError
  >,
) => {
  return (options.client ?? client).put<
    PublishTemplateTemplatesTemplateIdPublishPutResponses,
    PublishTemplateTemplatesTemplateIdPublishPutErrors,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/templates/{template_id}/publish',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });
};

/**
 * Disable Template Sharing
 *
 * Disable sharing for a template
 */
export const disableTemplateSharingTemplatesTemplateIdShareDelete = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    DisableTemplateSharingTemplatesTemplateIdShareDeleteData,
    ThrowOnError
  >,
) => {
  return (options.client ?? client).delete<
    DisableTemplateSharingTemplatesTemplateIdShareDeleteResponses,
    DisableTemplateSharingTemplatesTemplateIdShareDeleteErrors,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/templates/{template_id}/share',
    ...options,
  });
};

/**
 * Get Template Sharing Status
 *
 * Get the current sharing status of a template
 */
export const getTemplateSharingStatusTemplatesTemplateIdShareGet = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    GetTemplateSharingStatusTemplatesTemplateIdShareGetData,
    ThrowOnError
  >,
) => {
  return (options.client ?? client).get<
    GetTemplateSharingStatusTemplatesTemplateIdShareGetResponses,
    GetTemplateSharingStatusTemplatesTemplateIdShareGetErrors,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/templates/{template_id}/share',
    ...options,
  });
};

/**
 * Enable Template Sharing
 *
 * Enable sharing for a template for 48 hours
 */
export const enableTemplateSharingTemplatesTemplateIdSharePost = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    EnableTemplateSharingTemplatesTemplateIdSharePostData,
    ThrowOnError
  >,
) => {
  return (options.client ?? client).post<
    EnableTemplateSharingTemplatesTemplateIdSharePostResponses,
    EnableTemplateSharingTemplatesTemplateIdSharePostErrors,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/templates/{template_id}/share',
    ...options,
  });
};

/**
 * Get Open Sessions
 */
export const getOpenSessionsRoomsOpenSessionsGet = <
  ThrowOnError extends boolean = false,
>(
  options?: Options<GetOpenSessionsRoomsOpenSessionsGetData, ThrowOnError>,
) => {
  return (options?.client ?? client).get<
    GetOpenSessionsRoomsOpenSessionsGetResponses,
    GetOpenSessionsRoomsOpenSessionsGetErrors,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/rooms/open-sessions',
    ...options,
  });
};

/**
 * Get Company Insights
 */
export const getCompanyInsights = <ThrowOnError extends boolean = false>(
  options?: Options<GetCompanyInsightsData, ThrowOnError>,
) => {
  return (options?.client ?? client).get<
    GetCompanyInsightsResponses,
    GetCompanyInsightsErrors,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/rooms/company-insights',
    ...options,
  });
};

/**
 * Get Candidates
 */
export const getCandidatesRoomsCandidatesGet = <
  ThrowOnError extends boolean = false,
>(
  options?: Options<GetCandidatesRoomsCandidatesGetData, ThrowOnError>,
) => {
  return (options?.client ?? client).get<
    GetCandidatesRoomsCandidatesGetResponses,
    GetCandidatesRoomsCandidatesGetErrors,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/rooms/candidates',
    ...options,
  });
};

/**
 * Export Room Summary Csv
 */
export const exportRoomSummaryCsv = <ThrowOnError extends boolean = false>(
  options: Options<ExportRoomSummaryCsvData, ThrowOnError>,
) => {
  return (options.client ?? client).post<
    ExportRoomSummaryCsvResponses,
    ExportRoomSummaryCsvErrors,
    ThrowOnError
  >({
    responseType: 'text',
    url: '/rooms/export-summary/csv',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });
};

/**
 * Export Room Summary Pdf
 */
export const exportRoomSummaryPdf = <ThrowOnError extends boolean = false>(
  options: Options<ExportRoomSummaryPdfData, ThrowOnError>,
) => {
  return (options.client ?? client).post<
    ExportRoomSummaryPdfResponses,
    ExportRoomSummaryPdfErrors,
    ThrowOnError
  >({
    responseType: 'blob',
    url: '/rooms/export-summary/pdf',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });
};

/**
 * Generate Bulk Summaries
 *
 * Generate summaries for multiple applications in batch
 */
export const generateBulkSummariesRoomsGenerateSummaryPost = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    GenerateBulkSummariesRoomsGenerateSummaryPostData,
    ThrowOnError
  >,
) => {
  return (options.client ?? client).post<
    GenerateBulkSummariesRoomsGenerateSummaryPostResponses,
    GenerateBulkSummariesRoomsGenerateSummaryPostErrors,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/rooms/generate-summary',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });
};

/**
 * Delete Applications
 */
export const deleteApplicationsApplicationsDeleteApplicationsDelete = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    DeleteApplicationsApplicationsDeleteApplicationsDeleteData,
    ThrowOnError
  >,
) => {
  return (options.client ?? client).delete<
    DeleteApplicationsApplicationsDeleteApplicationsDeleteResponses,
    DeleteApplicationsApplicationsDeleteApplicationsDeleteErrors,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/applications/delete-applications',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });
};

/**
 * Request Call
 */
export const requestCallApplicationsRequestCallPost = <
  ThrowOnError extends boolean = false,
>(
  options: Options<RequestCallApplicationsRequestCallPostData, ThrowOnError>,
) => {
  return (options.client ?? client).post<
    RequestCallApplicationsRequestCallPostResponses,
    RequestCallApplicationsRequestCallPostErrors,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/applications/request-call',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });
};

/**
 * Cancel Interview
 *
 * The company cancels a candidate's booked interview from the dashboard.
 */
export const cancelInterview = <ThrowOnError extends boolean = false>(
  options: Options<CancelInterviewData, ThrowOnError>,
) => {
  return (options.client ?? client).post<
    CancelInterviewResponses,
    CancelInterviewErrors,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/applications/{application_id}/cancel-interview',
    ...options,
  });
};

/**
 * Archive Application
 */
export const archiveApplicationApplicationsArchivePost = <
  ThrowOnError extends boolean = false,
>(
  options: Options<ArchiveApplicationApplicationsArchivePostData, ThrowOnError>,
) => {
  return (options.client ?? client).post<
    ArchiveApplicationApplicationsArchivePostResponses,
    ArchiveApplicationApplicationsArchivePostErrors,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/applications/archive',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });
};

/**
 * Update Application Stage
 */
export const updateApplicationStageApplicationsUpdateStagePost = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    UpdateApplicationStageApplicationsUpdateStagePostData,
    ThrowOnError
  >,
) => {
  return (options.client ?? client).post<
    UpdateApplicationStageApplicationsUpdateStagePostResponses,
    UpdateApplicationStageApplicationsUpdateStagePostErrors,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/applications/update-stage',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });
};

/**
 * Add Application Comment
 */
export const addApplicationComment = <ThrowOnError extends boolean = false>(
  options: Options<AddApplicationCommentData, ThrowOnError>,
) => {
  return (options.client ?? client).post<
    AddApplicationCommentResponses,
    AddApplicationCommentErrors,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/applications/add-comment',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });
};

/**
 * Get Application Comments
 */
export const getApplicationComments = <ThrowOnError extends boolean = false>(
  options: Options<GetApplicationCommentsData, ThrowOnError>,
) => {
  return (options.client ?? client).get<
    GetApplicationCommentsResponses,
    GetApplicationCommentsErrors,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/applications/comments/{application_id}',
    ...options,
  });
};

/**
 * Get Candidate Feedback
 */
export const getCandidateFeedback = <ThrowOnError extends boolean = false>(
  options?: Options<GetCandidateFeedbackData, ThrowOnError>,
) => {
  return (options?.client ?? client).get<
    GetCandidateFeedbackResponses,
    GetCandidateFeedbackErrors,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/applications/feedback',
    ...options,
  });
};

/**
 * Get Candidates Count
 */
export const getCandidatesCount = <ThrowOnError extends boolean = false>(
  options: Options<GetCandidatesCountData, ThrowOnError>,
) => {
  return (options.client ?? client).get<
    GetCandidatesCountResponses,
    GetCandidatesCountErrors,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/applications/count',
    ...options,
  });
};

/**
 * Bulk Delete By Filter
 */
export const bulkDeleteByFilter = <ThrowOnError extends boolean = false>(
  options: Options<BulkDeleteByFilterData, ThrowOnError>,
) => {
  return (options.client ?? client).post<
    BulkDeleteByFilterResponses,
    BulkDeleteByFilterErrors,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/applications/bulk-delete-by-filter',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });
};

/**
 * Create Test
 */
export const createTestSessionsTestSessionPost = <
  ThrowOnError extends boolean = false,
>(
  options: Options<CreateTestSessionsTestSessionPostData, ThrowOnError>,
) => {
  return (options.client ?? client).post<
    CreateTestSessionsTestSessionPostResponses,
    CreateTestSessionsTestSessionPostErrors,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/sessions/test-session',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });
};

/**
 * Import Candidates
 */
export const importCandidatesSessionsTemplateIdImportPost = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    ImportCandidatesSessionsTemplateIdImportPostData,
    ThrowOnError
  >,
) => {
  return (options.client ?? client).post<
    ImportCandidatesSessionsTemplateIdImportPostResponses,
    ImportCandidatesSessionsTemplateIdImportPostErrors,
    ThrowOnError
  >({
    ...formDataBodySerializer,
    responseType: 'json',
    url: '/sessions/{template_id}/import',
    ...options,
    headers: {
      'Content-Type': null,
      ...options.headers,
    },
  });
};

/**
 * Invite Imported Candidates
 *
 * Invite imported candidates by scheduling interviews and sending invitation emails.
 * Creates cloud tasks to process each invitation asynchronously.
 */
export const inviteImportedCandidates = <ThrowOnError extends boolean = false>(
  options: Options<InviteImportedCandidatesData, ThrowOnError>,
) => {
  return (options.client ?? client).post<
    InviteImportedCandidatesResponses,
    InviteImportedCandidatesErrors,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/sessions/invite',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });
};

/**
 * Get Default Assessment Components
 *
 * Get all available default assessment components with their names, descriptions, and IDs
 */
export const getDefaultAssessmentComponents = <
  ThrowOnError extends boolean = false,
>(
  options?: Options<GetDefaultAssessmentComponentsData, ThrowOnError>,
) => {
  return (options?.client ?? client).get<
    GetDefaultAssessmentComponentsResponses,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/assessment_blocks/default',
    ...options,
  });
};

/**
 * Get All Assessment Components
 *
 * Get all available assessment components with their names, descriptions, and IDs
 */
export const getAllAssessmentComponents = <
  ThrowOnError extends boolean = false,
>(
  options?: Options<GetAllAssessmentComponentsData, ThrowOnError>,
) => {
  return (options?.client ?? client).get<
    GetAllAssessmentComponentsResponses,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/assessment_blocks/all',
    ...options,
  });
};

/**
 * Generate Session Template
 *
 * Generate a session template using AI based on user prompt
 */
export const generateSessionTemplateAiGenerationSessionTemplatePost = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    GenerateSessionTemplateAiGenerationSessionTemplatePostData,
    ThrowOnError
  >,
) => {
  return (options.client ?? client).post<
    GenerateSessionTemplateAiGenerationSessionTemplatePostResponses,
    GenerateSessionTemplateAiGenerationSessionTemplatePostErrors,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/ai-generation/session-template',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });
};

/**
 * Get Available Llm Models
 */
export const getAvailableLlmModels = <ThrowOnError extends boolean = false>(
  options?: Options<GetAvailableLlmModelsData, ThrowOnError>,
) => {
  return (options?.client ?? client).get<
    GetAvailableLlmModelsResponses,
    GetAvailableLlmModelsErrors,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/ai-generation/llm-models',
    ...options,
  });
};

/**
 * List Vertical Packs Endpoint
 */
export const listVerticalPacks = <ThrowOnError extends boolean = false>(
  options?: Options<ListVerticalPacksData, ThrowOnError>,
) => {
  return (options?.client ?? client).get<
    ListVerticalPacksResponses,
    ListVerticalPacksErrors,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/ai-generation/vertical-packs',
    ...options,
  });
};

/**
 * Preview Vertical Packs Endpoint
 */
export const previewVerticalPacks = <ThrowOnError extends boolean = false>(
  options: Options<PreviewVerticalPacksData, ThrowOnError>,
) => {
  return (options.client ?? client).post<
    PreviewVerticalPacksResponses,
    PreviewVerticalPacksErrors,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/ai-generation/vertical-packs/preview',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });
};

/**
 * Upload Pdf
 */
export const uploadPdfKnowledge = <ThrowOnError extends boolean = false>(
  options: Options<UploadPdfKnowledgeData, ThrowOnError>,
) => {
  return (options.client ?? client).post<
    UploadPdfKnowledgeResponses,
    UploadPdfKnowledgeErrors,
    ThrowOnError
  >({
    ...formDataBodySerializer,
    responseType: 'json',
    url: '/knowledge/upload-pdf',
    ...options,
    headers: {
      'Content-Type': null,
      ...options.headers,
    },
  });
};

/**
 * Upload Image
 */
export const uploadImageKnowledge = <ThrowOnError extends boolean = false>(
  options: Options<UploadImageKnowledgeData, ThrowOnError>,
) => {
  return (options.client ?? client).post<
    UploadImageKnowledgeResponses,
    UploadImageKnowledgeErrors,
    ThrowOnError
  >({
    ...formDataBodySerializer,
    responseType: 'json',
    url: '/knowledge/upload-image',
    ...options,
    headers: {
      'Content-Type': null,
      ...options.headers,
    },
  });
};

/**
 * Upload Listening
 */
export const uploadListeningKnowledge = <ThrowOnError extends boolean = false>(
  options: Options<UploadListeningKnowledgeData, ThrowOnError>,
) => {
  return (options.client ?? client).post<
    UploadListeningKnowledgeResponses,
    UploadListeningKnowledgeErrors,
    ThrowOnError
  >({
    ...formDataBodySerializer,
    responseType: 'json',
    url: '/knowledge/upload-listening',
    ...options,
    headers: {
      'Content-Type': null,
      ...options.headers,
    },
  });
};

/**
 * Upload Mp4
 */
export const uploadMp4Knowledge = <ThrowOnError extends boolean = false>(
  options: Options<UploadMp4KnowledgeData, ThrowOnError>,
) => {
  return (options.client ?? client).post<
    UploadMp4KnowledgeResponses,
    UploadMp4KnowledgeErrors,
    ThrowOnError
  >({
    ...formDataBodySerializer,
    responseType: 'json',
    url: '/knowledge/upload-mp4',
    ...options,
    headers: {
      'Content-Type': null,
      ...options.headers,
    },
  });
};

/**
 * Upload Youtube
 */
export const uploadYoutubeKnowledge = <ThrowOnError extends boolean = false>(
  options: Options<UploadYoutubeKnowledgeData, ThrowOnError>,
) => {
  return (options.client ?? client).post<
    UploadYoutubeKnowledgeResponses,
    UploadYoutubeKnowledgeErrors,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/knowledge/youtube',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });
};

/**
 * List By Template
 */
export const getKnowledgeByTemplate = <ThrowOnError extends boolean = false>(
  options: Options<GetKnowledgeByTemplateData, ThrowOnError>,
) => {
  return (options.client ?? client).get<
    GetKnowledgeByTemplateResponses,
    GetKnowledgeByTemplateErrors,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/knowledge/by-template/{template_id}',
    ...options,
  });
};

/**
 * Delete Knowledge Item
 */
export const deleteKnowledgeItem = <ThrowOnError extends boolean = false>(
  options: Options<DeleteKnowledgeItemData, ThrowOnError>,
) => {
  return (options.client ?? client).delete<
    DeleteKnowledgeItemResponses,
    DeleteKnowledgeItemErrors,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/knowledge/{knowledge_item_id}',
    ...options,
  });
};

/**
 * Generate Images
 *
 * Generate AI images for a session template based on its instructions.
 */
export const generateKnowledgeImages = <ThrowOnError extends boolean = false>(
  options: Options<GenerateKnowledgeImagesData, ThrowOnError>,
) => {
  return (options.client ?? client).post<
    GenerateKnowledgeImagesResponses,
    GenerateKnowledgeImagesErrors,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/knowledge/generate-images',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });
};

/**
 * List Groups
 */
export const listSessionGroups = <ThrowOnError extends boolean = false>(
  options?: Options<ListSessionGroupsData, ThrowOnError>,
) => {
  return (options?.client ?? client).get<
    ListSessionGroupsResponses,
    ListSessionGroupsErrors,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/session-groups/',
    ...options,
  });
};

/**
 * Create Group
 */
export const createSessionGroup = <ThrowOnError extends boolean = false>(
  options: Options<CreateSessionGroupData, ThrowOnError>,
) => {
  return (options.client ?? client).post<
    CreateSessionGroupResponses,
    CreateSessionGroupErrors,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/session-groups/',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });
};

/**
 * Delete Group
 */
export const deleteSessionGroup = <ThrowOnError extends boolean = false>(
  options: Options<DeleteSessionGroupData, ThrowOnError>,
) => {
  return (options.client ?? client).delete<
    DeleteSessionGroupResponses,
    DeleteSessionGroupErrors,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/session-groups/{group_id}',
    ...options,
  });
};

/**
 * Get Group
 */
export const getSessionGroup = <ThrowOnError extends boolean = false>(
  options: Options<GetSessionGroupData, ThrowOnError>,
) => {
  return (options.client ?? client).get<
    GetSessionGroupResponses,
    GetSessionGroupErrors,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/session-groups/{group_id}',
    ...options,
  });
};

/**
 * Update Group
 */
export const updateSessionGroup = <ThrowOnError extends boolean = false>(
  options: Options<UpdateSessionGroupData, ThrowOnError>,
) => {
  return (options.client ?? client).put<
    UpdateSessionGroupResponses,
    UpdateSessionGroupErrors,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/session-groups/{group_id}',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });
};

/**
 * Reorder Group
 */
export const orderSessionGroupTemplates = <
  ThrowOnError extends boolean = false,
>(
  options: Options<OrderSessionGroupTemplatesData, ThrowOnError>,
) => {
  return (options.client ?? client).put<
    OrderSessionGroupTemplatesResponses,
    OrderSessionGroupTemplatesErrors,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/session-groups/{group_id}/order',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });
};

/**
 * Publish Group
 */
export const publishSessionGroup = <ThrowOnError extends boolean = false>(
  options: Options<PublishSessionGroupData, ThrowOnError>,
) => {
  return (options.client ?? client).post<
    PublishSessionGroupResponses,
    PublishSessionGroupErrors,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/session-groups/{group_id}/publish',
    ...options,
  });
};

/**
 * Unpublish Group
 */
export const unpublishSessionGroup = <ThrowOnError extends boolean = false>(
  options: Options<UnpublishSessionGroupData, ThrowOnError>,
) => {
  return (options.client ?? client).post<
    UnpublishSessionGroupResponses,
    UnpublishSessionGroupErrors,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/session-groups/{group_id}/unpublish',
    ...options,
  });
};

/**
 * Get Public Group
 */
export const getPublicSessionGroup = <ThrowOnError extends boolean = false>(
  options: Options<GetPublicSessionGroupData, ThrowOnError>,
) => {
  return (options.client ?? client).get<
    GetPublicSessionGroupResponses,
    GetPublicSessionGroupErrors,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/session-groups/public/{public_id}',
    ...options,
  });
};

/**
 * Create Stage
 */
export const createStage = <ThrowOnError extends boolean = false>(
  options: Options<CreateStageData, ThrowOnError>,
) => {
  return (options.client ?? client).post<
    CreateStageResponses,
    CreateStageErrors,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/stages/',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });
};

/**
 * Get Stages
 */
export const getStages = <ThrowOnError extends boolean = false>(
  options: Options<GetStagesData, ThrowOnError>,
) => {
  return (options.client ?? client).get<
    GetStagesResponses,
    GetStagesErrors,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/stages/{session_template_id}',
    ...options,
  });
};

/**
 * Rename Stage
 */
export const renameStage = <ThrowOnError extends boolean = false>(
  options: Options<RenameStageData, ThrowOnError>,
) => {
  return (options.client ?? client).patch<
    RenameStageResponses,
    RenameStageErrors,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/stages/{stage_id}/rename',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });
};

/**
 * Delete Stage
 */
export const deleteStage = <ThrowOnError extends boolean = false>(
  options: Options<DeleteStageData, ThrowOnError>,
) => {
  return (options.client ?? client).delete<
    DeleteStageResponses,
    DeleteStageErrors,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/stages/{stage_id}',
    ...options,
  });
};

/**
 * Get Learn Sessions
 */
export const getLearnSessions = <ThrowOnError extends boolean = false>(
  options?: Options<GetLearnSessionsData, ThrowOnError>,
) => {
  return (options?.client ?? client).get<
    GetLearnSessionsResponses,
    GetLearnSessionsErrors,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/public/learn/sessions',
    ...options,
  });
};

/**
 * Get Popular Sessions
 */
export const getPopularLearnSessions = <ThrowOnError extends boolean = false>(
  options?: Options<GetPopularLearnSessionsData, ThrowOnError>,
) => {
  return (options?.client ?? client).get<
    GetPopularLearnSessionsResponses,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/public/learn/sessions/popular',
    ...options,
  });
};

/**
 * Get Categories
 */
export const getLearnCategories = <ThrowOnError extends boolean = false>(
  options?: Options<GetLearnCategoriesData, ThrowOnError>,
) => {
  return (options?.client ?? client).get<
    GetLearnCategoriesResponses,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/public/learn/categories',
    ...options,
  });
};

/**
 * Get Session Groups
 */
export const getLearnSessionGroups = <ThrowOnError extends boolean = false>(
  options?: Options<GetLearnSessionGroupsData, ThrowOnError>,
) => {
  return (options?.client ?? client).get<
    GetLearnSessionGroupsResponses,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/public/learn/session-groups',
    ...options,
  });
};

/**
 * Get Featured Session Groups
 */
export const getFeaturedSessionGroups = <ThrowOnError extends boolean = false>(
  options?: Options<GetFeaturedSessionGroupsData, ThrowOnError>,
) => {
  return (options?.client ?? client).get<
    GetFeaturedSessionGroupsResponses,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/public/learn/featured-session-groups',
    ...options,
  });
};

/**
 * Get Session Group Detail
 *
 * Get detailed session group info for learner view. Accepts public_id or _id.
 */
export const getLearnSessionGroupDetail = <
  ThrowOnError extends boolean = false,
>(
  options: Options<GetLearnSessionGroupDetailData, ThrowOnError>,
) => {
  return (options.client ?? client).get<
    GetLearnSessionGroupDetailResponses,
    GetLearnSessionGroupDetailErrors,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/public/learn/session-groups/{identifier}',
    ...options,
  });
};

/**
 * Get Group Visualization Status
 *
 * Get real-time visualization generation status for all sessions in a group.
 */
export const getGroupVisualizationStatus = <
  ThrowOnError extends boolean = false,
>(
  options: Options<GetGroupVisualizationStatusData, ThrowOnError>,
) => {
  return (options.client ?? client).get<
    GetGroupVisualizationStatusResponses,
    GetGroupVisualizationStatusErrors,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/public/learn/session-groups/{group_id}/visualization-status',
    ...options,
  });
};

/**
 * List Generation Gallery
 */
export const listGenerationGallery = <ThrowOnError extends boolean = false>(
  options?: Options<ListGenerationGalleryData, ThrowOnError>,
) => {
  return (options?.client ?? client).get<
    ListGenerationGalleryResponses,
    ListGenerationGalleryErrors,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/learn/generation-gallery',
    ...options,
  });
};

/**
 * Get My Gamification
 */
export const getMyGamification = <ThrowOnError extends boolean = false>(
  options?: Options<GetMyGamificationData, ThrowOnError>,
) => {
  return (options?.client ?? client).get<
    GetMyGamificationResponses,
    GetMyGamificationErrors,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/learn/my-gamification',
    ...options,
  });
};

/**
 * Enroll In Session Group
 */
export const enrollInSessionGroup = <ThrowOnError extends boolean = false>(
  options: Options<EnrollInSessionGroupData, ThrowOnError>,
) => {
  return (options.client ?? client).post<
    EnrollInSessionGroupResponses,
    EnrollInSessionGroupErrors,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/learn/enroll/{public_id}',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });
};

/**
 * Get My Enrollments
 */
export const getMyEnrollments = <ThrowOnError extends boolean = false>(
  options?: Options<GetMyEnrollmentsData, ThrowOnError>,
) => {
  return (options?.client ?? client).get<
    GetMyEnrollmentsResponses,
    GetMyEnrollmentsErrors,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/learn/my-enrollments',
    ...options,
  });
};

/**
 * Get My Session Result
 *
 * Get the learner's most recent completed application for a session template.
 */
export const getMySessionResult = <ThrowOnError extends boolean = false>(
  options: Options<GetMySessionResultData, ThrowOnError>,
) => {
  return (options.client ?? client).get<
    GetMySessionResultResponses,
    GetMySessionResultErrors,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/learn/my-session-result/{session_template_id}',
    ...options,
  });
};

/**
 * Toggle Learning Path Visibility
 *
 * Allow the owner to hide/show their learning path from the explore page.
 */
export const toggleLearningPathVisibility = <
  ThrowOnError extends boolean = false,
>(
  options: Options<ToggleLearningPathVisibilityData, ThrowOnError>,
) => {
  return (options.client ?? client).patch<
    ToggleLearningPathVisibilityResponses,
    ToggleLearningPathVisibilityErrors,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/learn/session-group/{group_id}/visibility',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });
};

/**
 * Upload Cover Image
 *
 * Upload a custom cover image for a learning path (owner only).
 */
export const uploadLearningPathCoverImage = <
  ThrowOnError extends boolean = false,
>(
  options: Options<UploadLearningPathCoverImageData, ThrowOnError>,
) => {
  return (options.client ?? client).put<
    UploadLearningPathCoverImageResponses,
    UploadLearningPathCoverImageErrors,
    ThrowOnError
  >({
    ...formDataBodySerializer,
    responseType: 'json',
    url: '/learn/session-group/{group_id}/cover-image',
    ...options,
    headers: {
      'Content-Type': null,
      ...options.headers,
    },
  });
};

/**
 * Generate Learning Path
 *
 * Generate a complete learning path with multiple sessions from a prompt.
 */
export const generateLearningPath = <ThrowOnError extends boolean = false>(
  options: Options<GenerateLearningPathData, ThrowOnError>,
) => {
  return (options.client ?? client).post<
    GenerateLearningPathResponses,
    GenerateLearningPathErrors,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/learn/generate-learning-path',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });
};

/**
 * Upload Learning Document
 *
 * Upload a PDF (book, lesson notes) to generate lessons from.
 */
export const uploadLearningDocument = <ThrowOnError extends boolean = false>(
  options: Options<UploadLearningDocumentData, ThrowOnError>,
) => {
  return (options.client ?? client).post<
    UploadLearningDocumentResponses,
    UploadLearningDocumentErrors,
    ThrowOnError
  >({
    ...formDataBodySerializer,
    responseType: 'json',
    url: '/learn/documents',
    ...options,
    headers: {
      'Content-Type': null,
      ...options.headers,
    },
  });
};

/**
 * Import Learning Document Url
 *
 * Scrape a web page or PDF link (text and images) to generate lessons from.
 */
export const importLearningDocumentUrl = <ThrowOnError extends boolean = false>(
  options: Options<ImportLearningDocumentUrlData, ThrowOnError>,
) => {
  return (options.client ?? client).post<
    ImportLearningDocumentUrlResponses,
    ImportLearningDocumentUrlErrors,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/learn/documents/url',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });
};

/**
 * List Library Books
 *
 * Open textbooks (OpenStax) a learner can pick a chapter from.
 */
export const listLibraryBooks = <ThrowOnError extends boolean = false>(
  options?: Options<ListLibraryBooksData, ThrowOnError>,
) => {
  return (options?.client ?? client).get<
    ListLibraryBooksResponses,
    ListLibraryBooksErrors,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/learn/library/books',
    ...options,
  });
};

/**
 * Get Library Book
 */
export const getLibraryBook = <ThrowOnError extends boolean = false>(
  options: Options<GetLibraryBookData, ThrowOnError>,
) => {
  return (options.client ?? client).get<
    GetLibraryBookResponses,
    GetLibraryBookErrors,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/learn/library/books/{book_id}',
    ...options,
  });
};

/**
 * Import Library Chapter
 *
 * Turn one chapter of an open textbook into a learning document.
 */
export const importLibraryChapter = <ThrowOnError extends boolean = false>(
  options: Options<ImportLibraryChapterData, ThrowOnError>,
) => {
  return (options.client ?? client).post<
    ImportLibraryChapterResponses,
    ImportLibraryChapterErrors,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/learn/documents/library',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });
};

/**
 * Get Learning Document
 */
export const getLearningDocument = <ThrowOnError extends boolean = false>(
  options: Options<GetLearningDocumentData, ThrowOnError>,
) => {
  return (options.client ?? client).get<
    GetLearningDocumentResponses,
    GetLearningDocumentErrors,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/learn/documents/{document_id}',
    ...options,
  });
};

/**
 * Generate Learning Path Chat
 *
 * Stream creation of a single session or a session group from chat using the AI SDK data stream protocol.
 */
export const generateLearningPathChat = <ThrowOnError extends boolean = false>(
  options: Options<GenerateLearningPathChatData, ThrowOnError>,
) => {
  return (options.client ?? client).post<
    GenerateLearningPathChatResponses,
    GenerateLearningPathChatErrors,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/learn/generate-learning-path-chat',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });
};

/**
 * Chat Followup
 *
 * Follow-up chat for an existing learning path: course questions, language, and voice.
 */
export const chatFollowup = <ThrowOnError extends boolean = false>(
  options: Options<ChatFollowupData, ThrowOnError>,
) => {
  return (options.client ?? client).post<
    ChatFollowupResponses,
    ChatFollowupErrors,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/learn/chat-followup',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });
};

/**
 * Generate User Learning Path
 *
 * Generate a personalized learning path for a user based on their session and email it to them.
 */
export const generateUserLearningPath = <ThrowOnError extends boolean = false>(
  options: Options<GenerateUserLearningPathData, ThrowOnError>,
) => {
  return (options.client ?? client).post<
    GenerateUserLearningPathResponses,
    GenerateUserLearningPathErrors,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/learn/generate-user-learning-path',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });
};

/**
 * Link Session To User
 *
 * Link an anonymous session to a registered user. Email must match.
 */
export const linkSessionToUser = <ThrowOnError extends boolean = false>(
  options: Options<LinkSessionToUserData, ThrowOnError>,
) => {
  return (options.client ?? client).post<
    LinkSessionToUserResponses,
    LinkSessionToUserErrors,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/public/link-session',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });
};

/**
 * Get Review Studio Access
 *
 * Whether this signed-in company user may open Review Studio. Never 403s — returns allowed=false.
 */
export const getReviewStudioAccess = <ThrowOnError extends boolean = false>(
  options?: Options<GetReviewStudioAccessData, ThrowOnError>,
) => {
  return (options?.client ?? client).get<
    GetReviewStudioAccessResponses,
    GetReviewStudioAccessErrors,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/reviews/access',
    ...options,
  });
};

/**
 * Search Review Sessions
 *
 * List latest live tutoring sessions for Review Studio, with search filters.
 */
export const searchReviewSessions = <ThrowOnError extends boolean = false>(
  options?: Options<SearchReviewSessionsData, ThrowOnError>,
) => {
  return (options?.client ?? client).get<
    SearchReviewSessionsResponses,
    SearchReviewSessionsErrors,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/reviews/sessions',
    ...options,
  });
};

/**
 * Get Review Session
 *
 * Interleaved timeline, prompts, materials, and video stories for one live session.
 */
export const getReviewSession = <ThrowOnError extends boolean = false>(
  options: Options<GetReviewSessionData, ThrowOnError>,
) => {
  return (options.client ?? client).get<
    GetReviewSessionResponses,
    GetReviewSessionErrors,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/reviews/sessions/{room_id}',
    ...options,
  });
};

/**
 * Upsert Review Session Annotation
 *
 * Create or update a human annotation on a session or timeline item.
 */
export const upsertReviewSessionAnnotation = <
  ThrowOnError extends boolean = false,
>(
  options: Options<UpsertReviewSessionAnnotationData, ThrowOnError>,
) => {
  return (options.client ?? client).put<
    UpsertReviewSessionAnnotationResponses,
    UpsertReviewSessionAnnotationErrors,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/reviews/sessions/{room_id}/annotations',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });
};

/**
 * Fork Review Session
 *
 * Copy the session into a new room that continues the conversation after one transcript line.
 */
export const forkReviewSession = <ThrowOnError extends boolean = false>(
  options: Options<ForkReviewSessionData, ThrowOnError>,
) => {
  return (options.client ?? client).post<
    ForkReviewSessionResponses,
    ForkReviewSessionErrors,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/reviews/sessions/{room_id}/fork',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });
};

/**
 * Queue Review Video Retry
 *
 * Store retry params on a video story. Prefer /reviews/generations/{id}/retry for regen.
 */
export const queueReviewVideoRetry = <ThrowOnError extends boolean = false>(
  options: Options<QueueReviewVideoRetryData, ThrowOnError>,
) => {
  return (options.client ?? client).post<
    QueueReviewVideoRetryResponses,
    QueueReviewVideoRetryErrors,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/reviews/sessions/{room_id}/video-retry',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });
};

/**
 * List Review Generations
 *
 * List chat-driven generation runs for Generation Inspector.
 */
export const listReviewGenerations = <ThrowOnError extends boolean = false>(
  options?: Options<ListReviewGenerationsData, ThrowOnError>,
) => {
  return (options?.client ?? client).get<
    ListReviewGenerationsResponses,
    ListReviewGenerationsErrors,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/reviews/generations',
    ...options,
  });
};

/**
 * Get Review Generation
 *
 * Full low-level generation tree: strategy, plan, stills, keyframes, clips.
 */
export const getReviewGeneration = <ThrowOnError extends boolean = false>(
  options: Options<GetReviewGenerationData, ThrowOnError>,
) => {
  return (options.client ?? client).get<
    GetReviewGenerationResponses,
    GetReviewGenerationErrors,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/reviews/generations/{run_id}',
    ...options,
  });
};

/**
 * Upsert Review Generation Review
 *
 * Taste / quality / hallucination score on a generation run or child artifact.
 */
export const upsertReviewGenerationReview = <
  ThrowOnError extends boolean = false,
>(
  options: Options<UpsertReviewGenerationReviewData, ThrowOnError>,
) => {
  return (options.client ?? client).put<
    UpsertReviewGenerationReviewResponses,
    UpsertReviewGenerationReviewErrors,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/reviews/generations/{run_id}/reviews',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });
};

/**
 * Retry Review Generation Artifact
 *
 * Edit prompt and regen one cover / still / keyframe / clip.
 */
export const retryReviewGenerationArtifact = <
  ThrowOnError extends boolean = false,
>(
  options: Options<RetryReviewGenerationArtifactData, ThrowOnError>,
) => {
  return (options.client ?? client).post<
    RetryReviewGenerationArtifactResponses,
    RetryReviewGenerationArtifactErrors,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/reviews/generations/{run_id}/retry',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });
};

/**
 * Get Dashboard
 *
 * Baselines and score history per fixture, runs in progress, evaluators, labeling progress.
 */
export const getEvalDashboard = <ThrowOnError extends boolean = false>(
  options?: Options<GetEvalDashboardData, ThrowOnError>,
) => {
  return (options?.client ?? client).get<
    GetEvalDashboardResponses,
    GetEvalDashboardErrors,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/evals/dashboard',
    ...options,
  });
};

/**
 * Get Options
 */
export const getEvalOptions = <ThrowOnError extends boolean = false>(
  options?: Options<GetEvalOptionsData, ThrowOnError>,
) => {
  return (options?.client ?? client).get<
    GetEvalOptionsResponses,
    GetEvalOptionsErrors,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/evals/options',
    ...options,
  });
};

/**
 * List Fixtures
 */
export const listEvalFixtures = <ThrowOnError extends boolean = false>(
  options?: Options<ListEvalFixturesData, ThrowOnError>,
) => {
  return (options?.client ?? client).get<
    ListEvalFixturesResponses,
    ListEvalFixturesErrors,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/evals/fixtures',
    ...options,
  });
};

/**
 * Create Fixture
 *
 * Freeze a session template as an eval fixture.
 */
export const createEvalFixture = <ThrowOnError extends boolean = false>(
  options: Options<CreateEvalFixtureData, ThrowOnError>,
) => {
  return (options.client ?? client).post<
    CreateEvalFixtureResponses,
    CreateEvalFixtureErrors,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/evals/fixtures',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });
};

/**
 * Update Fixture
 */
export const updateEvalFixture = <ThrowOnError extends boolean = false>(
  options: Options<UpdateEvalFixtureData, ThrowOnError>,
) => {
  return (options.client ?? client).patch<
    UpdateEvalFixtureResponses,
    UpdateEvalFixtureErrors,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/evals/fixtures/{fixture_id}',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });
};

/**
 * List Experiments
 */
export const listEvalExperiments = <ThrowOnError extends boolean = false>(
  options?: Options<ListEvalExperimentsData, ThrowOnError>,
) => {
  return (options?.client ?? client).get<
    ListEvalExperimentsResponses,
    ListEvalExperimentsErrors,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/evals/experiments',
    ...options,
  });
};

/**
 * Create Experiment
 *
 * Queue live runs for fixtures × personas × learner voices; the local runner picks them up.
 */
export const createEvalExperiment = <ThrowOnError extends boolean = false>(
  options: Options<CreateEvalExperimentData, ThrowOnError>,
) => {
  return (options.client ?? client).post<
    CreateEvalExperimentResponses,
    CreateEvalExperimentErrors,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/evals/experiments',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });
};

/**
 * Get Experiment
 */
export const getEvalExperiment = <ThrowOnError extends boolean = false>(
  options: Options<GetEvalExperimentData, ThrowOnError>,
) => {
  return (options.client ?? client).get<
    GetEvalExperimentResponses,
    GetEvalExperimentErrors,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/evals/experiments/{experiment_id}',
    ...options,
  });
};

/**
 * Set Baseline
 *
 * Make this experiment the baseline of every fixture it ran.
 */
export const setEvalBaseline = <ThrowOnError extends boolean = false>(
  options: Options<SetEvalBaselineData, ThrowOnError>,
) => {
  return (options.client ?? client).post<
    SetEvalBaselineResponses,
    SetEvalBaselineErrors,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/evals/experiments/{experiment_id}/baseline',
    ...options,
  });
};

/**
 * Cancel Experiment
 */
export const cancelEvalExperiment = <ThrowOnError extends boolean = false>(
  options: Options<CancelEvalExperimentData, ThrowOnError>,
) => {
  return (options.client ?? client).post<
    CancelEvalExperimentResponses,
    CancelEvalExperimentErrors,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/evals/experiments/{experiment_id}/cancel',
    ...options,
  });
};

/**
 * Evaluate Experiment
 *
 * Re-score every finished run with the current evaluator versions (the runner does the work).
 */
export const evaluateEvalExperiment = <ThrowOnError extends boolean = false>(
  options: Options<EvaluateEvalExperimentData, ThrowOnError>,
) => {
  return (options.client ?? client).post<
    EvaluateEvalExperimentResponses,
    EvaluateEvalExperimentErrors,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/evals/experiments/{experiment_id}/evaluate',
    ...options,
  });
};

/**
 * List Runs
 */
export const listEvalRuns = <ThrowOnError extends boolean = false>(
  options?: Options<ListEvalRunsData, ThrowOnError>,
) => {
  return (options?.client ?? client).get<
    ListEvalRunsResponses,
    ListEvalRunsErrors,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/evals/runs',
    ...options,
  });
};

/**
 * Evaluate All Runs
 *
 * Re-score every finished run, e.g. after a new judge version, so its alignment with your labels can be measured.
 */
export const evaluateAllEvalRuns = <ThrowOnError extends boolean = false>(
  options?: Options<EvaluateAllEvalRunsData, ThrowOnError>,
) => {
  return (options?.client ?? client).post<
    EvaluateAllEvalRunsResponses,
    EvaluateAllEvalRunsErrors,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/evals/runs/evaluate',
    ...options,
  });
};

/**
 * Evaluate Run
 */
export const evaluateEvalRun = <ThrowOnError extends boolean = false>(
  options: Options<EvaluateEvalRunData, ThrowOnError>,
) => {
  return (options.client ?? client).post<
    EvaluateEvalRunResponses,
    EvaluateEvalRunErrors,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/evals/runs/{run_id}/evaluate',
    ...options,
  });
};

/**
 * List Evaluators
 */
export const listEvaluators = <ThrowOnError extends boolean = false>(
  options?: Options<ListEvaluatorsData, ThrowOnError>,
) => {
  return (options?.client ?? client).get<
    ListEvaluatorsResponses,
    ListEvaluatorsErrors,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/evals/evaluators',
    ...options,
  });
};

/**
 * Create Evaluator
 *
 * A new LLM judge (code checks are built in).
 */
export const createEvaluator = <ThrowOnError extends boolean = false>(
  options: Options<CreateEvaluatorData, ThrowOnError>,
) => {
  return (options.client ?? client).post<
    CreateEvaluatorResponses,
    CreateEvaluatorErrors,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/evals/evaluators',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });
};

/**
 * Get Evaluator
 *
 * Versions, alignment with human labels per version, and the lines where judge and human disagree.
 */
export const getEvaluator = <ThrowOnError extends boolean = false>(
  options: Options<GetEvaluatorData, ThrowOnError>,
) => {
  return (options.client ?? client).get<
    GetEvaluatorResponses,
    GetEvaluatorErrors,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/evals/evaluators/{evaluator_id}',
    ...options,
  });
};

/**
 * Update Evaluator
 *
 * A changed prompt, model or threshold creates a new version and makes it current.
 */
export const updateEvaluator = <ThrowOnError extends boolean = false>(
  options: Options<UpdateEvaluatorData, ThrowOnError>,
) => {
  return (options.client ?? client).patch<
    UpdateEvaluatorResponses,
    UpdateEvaluatorErrors,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/evals/evaluators/{evaluator_id}',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });
};

/**
 * Set Evaluator Version
 */
export const setEvaluatorVersion = <ThrowOnError extends boolean = false>(
  options: Options<SetEvaluatorVersionData, ThrowOnError>,
) => {
  return (options.client ?? client).post<
    SetEvaluatorVersionResponses,
    SetEvaluatorVersionErrors,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/evals/evaluators/{evaluator_id}/versions/{version}',
    ...options,
  });
};

/**
 * Labeling Queue
 */
export const getEvalLabelingQueue = <ThrowOnError extends boolean = false>(
  options?: Options<GetEvalLabelingQueueData, ThrowOnError>,
) => {
  return (options?.client ?? client).get<
    GetEvalLabelingQueueResponses,
    GetEvalLabelingQueueErrors,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/evals/labeling',
    ...options,
  });
};

/**
 * Watch Run
 *
 * A hidden, listen-only LiveKit token to watch a running session: both voices, transcript, screen, debug events.
 */
export const getEvalWatchToken = <ThrowOnError extends boolean = false>(
  options: Options<GetEvalWatchTokenData, ThrowOnError>,
) => {
  return (options.client ?? client).get<
    GetEvalWatchTokenResponses,
    GetEvalWatchTokenErrors,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/evals/runs/{run_id}/watch',
    ...options,
  });
};

/**
 * Run Lines
 */
export const listEvalRunLines = <ThrowOnError extends boolean = false>(
  options: Options<ListEvalRunLinesData, ThrowOnError>,
) => {
  return (options.client ?? client).get<
    ListEvalRunLinesResponses,
    ListEvalRunLinesErrors,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/evals/runs/{run_id}/lines',
    ...options,
  });
};

/**
 * Fixture Prompts
 *
 * The prompts the fixture's latest run used, to start an experiment's prompt overrides from.
 */
export const getEvalFixturePrompts = <ThrowOnError extends boolean = false>(
  options: Options<GetEvalFixturePromptsData, ThrowOnError>,
) => {
  return (options.client ?? client).get<
    GetEvalFixturePromptsResponses,
    GetEvalFixturePromptsErrors,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/evals/fixtures/{fixture_id}/prompts',
    ...options,
  });
};

/**
 * List Replays
 */
export const listEvalReplays = <ThrowOnError extends boolean = false>(
  options?: Options<ListEvalReplaysData, ThrowOnError>,
) => {
  return (options?.client ?? client).get<
    ListEvalReplaysResponses,
    ListEvalReplaysErrors,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/evals/replays',
    ...options,
  });
};

/**
 * Create Replay
 *
 * Regenerate the selected tutor lines under a variant (model / instructions); the runner judges both versions.
 */
export const createEvalReplay = <ThrowOnError extends boolean = false>(
  options: Options<CreateEvalReplayData, ThrowOnError>,
) => {
  return (options.client ?? client).post<
    CreateEvalReplayResponses,
    CreateEvalReplayErrors,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/evals/replays',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });
};

/**
 * Get Replay
 */
export const getEvalReplay = <ThrowOnError extends boolean = false>(
  options: Options<GetEvalReplayData, ThrowOnError>,
) => {
  return (options.client ?? client).get<
    GetEvalReplayResponses,
    GetEvalReplayErrors,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/evals/replays/{replay_id}',
    ...options,
  });
};

/**
 * Label Queue
 *
 * Your next unlabeled tutor lines with context, alternating judge-bad and judge-good, plus your agreement so far.
 */
export const getEvalLabelQueue = <ThrowOnError extends boolean = false>(
  options?: Options<GetEvalLabelQueueData, ThrowOnError>,
) => {
  return (options?.client ?? client).get<
    GetEvalLabelQueueResponses,
    GetEvalLabelQueueErrors,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/evals/label-queue',
    ...options,
  });
};

/**
 * Admin Trigger Deletions
 *
 * Manually trigger deletion processing (admin only)
 */
export const triggerDeletionProcessing = <ThrowOnError extends boolean = false>(
  options?: Options<TriggerDeletionProcessingData, ThrowOnError>,
) => {
  return (options?.client ?? client).post<
    TriggerDeletionProcessingResponses,
    TriggerDeletionProcessingErrors,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/gdpr/admin/trigger-deletions',
    ...options,
  });
};

/**
 * Admin Trigger Exports
 *
 * Manually trigger export processing (admin only)
 */
export const triggerExportProcessing = <ThrowOnError extends boolean = false>(
  options?: Options<TriggerExportProcessingData, ThrowOnError>,
) => {
  return (options?.client ?? client).post<
    TriggerExportProcessingResponses,
    TriggerExportProcessingErrors,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/gdpr/admin/trigger-exports',
    ...options,
  });
};

/**
 * Admin Trigger Retention
 *
 * Manually trigger retention policy enforcement (admin only)
 */
export const triggerRetentionCleanup = <ThrowOnError extends boolean = false>(
  options?: Options<TriggerRetentionCleanupData, ThrowOnError>,
) => {
  return (options?.client ?? client).post<
    TriggerRetentionCleanupResponses,
    TriggerRetentionCleanupErrors,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/gdpr/admin/trigger-retention',
    ...options,
  });
};

/**
 * Admin Get Queue Status
 *
 * Get GDPR task queue status (admin only)
 */
export const getGdprQueueStatus = <ThrowOnError extends boolean = false>(
  options?: Options<GetGdprQueueStatusData, ThrowOnError>,
) => {
  return (options?.client ?? client).get<
    GetGdprQueueStatusResponses,
    GetGdprQueueStatusErrors,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/gdpr/admin/queue-status',
    ...options,
  });
};

/**
 * Get User Data Summary
 *
 * Get summary of all data associated with current user
 */
export const getUserDataSummaryGdprDataSummaryGet = <
  ThrowOnError extends boolean = false,
>(
  options?: Options<GetUserDataSummaryGdprDataSummaryGetData, ThrowOnError>,
) => {
  return (options?.client ?? client).get<
    GetUserDataSummaryGdprDataSummaryGetResponses,
    GetUserDataSummaryGdprDataSummaryGetErrors,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/gdpr/data-summary',
    ...options,
  });
};

/**
 * Get User Data Summary By Email
 *
 * Get summary of all data associated with an email (public endpoint)
 */
export const getUserDataSummaryByEmailGdprDataSummaryEmailGet = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    GetUserDataSummaryByEmailGdprDataSummaryEmailGetData,
    ThrowOnError
  >,
) => {
  return (options.client ?? client).get<
    GetUserDataSummaryByEmailGdprDataSummaryEmailGetResponses,
    GetUserDataSummaryByEmailGdprDataSummaryEmailGetErrors,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/gdpr/data-summary/{email}',
    ...options,
  });
};

/**
 * Request Data Export
 *
 * Request data export for current user
 */
export const requestDataExportGdprExportPost = <
  ThrowOnError extends boolean = false,
>(
  options: Options<RequestDataExportGdprExportPostData, ThrowOnError>,
) => {
  return (options.client ?? client).post<
    RequestDataExportGdprExportPostResponses,
    RequestDataExportGdprExportPostErrors,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/gdpr/export',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });
};

/**
 * Request Data Export Public
 *
 * Request data export (public endpoint)
 */
export const requestDataExportPublicGdprExportPublicPost = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    RequestDataExportPublicGdprExportPublicPostData,
    ThrowOnError
  >,
) => {
  return (options.client ?? client).post<
    RequestDataExportPublicGdprExportPublicPostResponses,
    RequestDataExportPublicGdprExportPublicPostErrors,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/gdpr/export/public',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });
};

/**
 * Get Export Status
 *
 * Get status of data export
 */
export const getExportStatusGdprExportExportIdStatusGet = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    GetExportStatusGdprExportExportIdStatusGetData,
    ThrowOnError
  >,
) => {
  return (options.client ?? client).get<
    GetExportStatusGdprExportExportIdStatusGetResponses,
    GetExportStatusGdprExportExportIdStatusGetErrors,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/gdpr/export/{export_id}/status',
    ...options,
  });
};

/**
 * Request Account Deletion
 *
 * Request account deletion for current user
 */
export const requestAccountDeletionGdprDeleteAccountPost = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    RequestAccountDeletionGdprDeleteAccountPostData,
    ThrowOnError
  >,
) => {
  return (options.client ?? client).post<
    RequestAccountDeletionGdprDeleteAccountPostResponses,
    RequestAccountDeletionGdprDeleteAccountPostErrors,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/gdpr/delete-account',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });
};

/**
 * Request Account Deletion Public
 *
 * Request account deletion (public endpoint)
 */
export const requestAccountDeletionPublicGdprDeleteAccountPublicPost = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    RequestAccountDeletionPublicGdprDeleteAccountPublicPostData,
    ThrowOnError
  >,
) => {
  return (options.client ?? client).post<
    RequestAccountDeletionPublicGdprDeleteAccountPublicPostResponses,
    RequestAccountDeletionPublicGdprDeleteAccountPublicPostErrors,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/gdpr/delete-account/public',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });
};

/**
 * Get Deletion Status
 *
 * Get status of account deletion
 */
export const getDeletionStatusGdprDeletionStatusJobIdGet = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    GetDeletionStatusGdprDeletionStatusJobIdGetData,
    ThrowOnError
  >,
) => {
  return (options.client ?? client).get<
    GetDeletionStatusGdprDeletionStatusJobIdGetResponses,
    GetDeletionStatusGdprDeletionStatusJobIdGetErrors,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/gdpr/deletion-status/{job_id}',
    ...options,
  });
};

/**
 * Get Compliance Status
 *
 * Get GDPR compliance status for user's company
 */
export const getComplianceStatusGdprComplianceStatusGet = <
  ThrowOnError extends boolean = false,
>(
  options?: Options<
    GetComplianceStatusGdprComplianceStatusGetData,
    ThrowOnError
  >,
) => {
  return (options?.client ?? client).get<
    GetComplianceStatusGdprComplianceStatusGetResponses,
    GetComplianceStatusGdprComplianceStatusGetErrors,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/gdpr/compliance-status',
    ...options,
  });
};

/**
 * Get Audit Logs
 *
 * Get GDPR audit logs for user's company
 */
export const getAuditLogsGdprAuditLogsGet = <
  ThrowOnError extends boolean = false,
>(
  options?: Options<GetAuditLogsGdprAuditLogsGetData, ThrowOnError>,
) => {
  return (options?.client ?? client).get<
    GetAuditLogsGdprAuditLogsGetResponses,
    GetAuditLogsGdprAuditLogsGetErrors,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/gdpr/audit-logs',
    ...options,
  });
};

/**
 * List Members
 */
export const listMembersMembersGet = <ThrowOnError extends boolean = false>(
  options?: Options<ListMembersMembersGetData, ThrowOnError>,
) => {
  return (options?.client ?? client).get<
    ListMembersMembersGetResponses,
    ListMembersMembersGetErrors,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/members/',
    ...options,
  });
};

/**
 * Invite Member
 */
export const inviteMemberMembersInvitePost = <
  ThrowOnError extends boolean = false,
>(
  options: Options<InviteMemberMembersInvitePostData, ThrowOnError>,
) => {
  return (options.client ?? client).post<
    InviteMemberMembersInvitePostResponses,
    InviteMemberMembersInvitePostErrors,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/members/invite',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });
};

/**
 * Revoke Invitation
 */
export const revokeInvitationMembersRevokePost = <
  ThrowOnError extends boolean = false,
>(
  options: Options<RevokeInvitationMembersRevokePostData, ThrowOnError>,
) => {
  return (options.client ?? client).post<
    RevokeInvitationMembersRevokePostResponses,
    RevokeInvitationMembersRevokePostErrors,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/members/revoke',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });
};

/**
 * Update Role
 */
export const updateRoleMembersRolePost = <ThrowOnError extends boolean = false>(
  options: Options<UpdateRoleMembersRolePostData, ThrowOnError>,
) => {
  return (options.client ?? client).post<
    UpdateRoleMembersRolePostResponses,
    UpdateRoleMembersRolePostErrors,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/members/role',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });
};

/**
 * Delete Member
 */
export const deleteMemberMembersUserIdDelete = <
  ThrowOnError extends boolean = false,
>(
  options: Options<DeleteMemberMembersUserIdDeleteData, ThrowOnError>,
) => {
  return (options.client ?? client).delete<
    DeleteMemberMembersUserIdDeleteResponses,
    DeleteMemberMembersUserIdDeleteErrors,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/members/{user_id}',
    ...options,
  });
};

/**
 * Get Leads
 */
export const getLeads = <ThrowOnError extends boolean = false>(
  options?: Options<GetLeadsData, ThrowOnError>,
) => {
  return (options?.client ?? client).get<
    GetLeadsResponses,
    GetLeadsErrors,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/leads',
    ...options,
  });
};

/**
 * Get Lead Sessions
 */
export const getLeadSessions = <ThrowOnError extends boolean = false>(
  options: Options<GetLeadSessionsData, ThrowOnError>,
) => {
  return (options.client ?? client).get<
    GetLeadSessionsResponses,
    GetLeadSessionsErrors,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/leads/{user_id}/sessions',
    ...options,
  });
};

/**
 * Get Lead Session Rooms
 */
export const getLeadSessionRooms = <ThrowOnError extends boolean = false>(
  options: Options<GetLeadSessionRoomsData, ThrowOnError>,
) => {
  return (options.client ?? client).get<
    GetLeadSessionRoomsResponses,
    GetLeadSessionRoomsErrors,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/leads/sessions/{session_template_id}/rooms',
    ...options,
  });
};

/**
 * Upsert Watch
 */
export const practiceUpsertWatch = <ThrowOnError extends boolean = false>(
  options: Options<PracticeUpsertWatchData, ThrowOnError>,
) => {
  return (options.client ?? client).post<
    PracticeUpsertWatchResponses,
    PracticeUpsertWatchErrors,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/practice/watch',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });
};

/**
 * Get History
 */
export const practiceGetHistory = <ThrowOnError extends boolean = false>(
  options?: Options<PracticeGetHistoryData, ThrowOnError>,
) => {
  return (options?.client ?? client).get<
    PracticeGetHistoryResponses,
    PracticeGetHistoryErrors,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/practice/history',
    ...options,
  });
};

/**
 * Get Transcript
 */
export const practiceGetTranscript = <ThrowOnError extends boolean = false>(
  options: Options<PracticeGetTranscriptData, ThrowOnError>,
) => {
  return (options.client ?? client).get<
    PracticeGetTranscriptResponses,
    PracticeGetTranscriptErrors,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/practice/transcripts/{episode_key}',
    ...options,
  });
};

/**
 * Ensure Course
 */
export const practiceEnsureCourse = <ThrowOnError extends boolean = false>(
  options: Options<PracticeEnsureCourseData, ThrowOnError>,
) => {
  return (options.client ?? client).post<
    PracticeEnsureCourseResponses,
    PracticeEnsureCourseErrors,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/practice/courses',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });
};

/**
 * Get Course
 */
export const practiceGetCourse = <ThrowOnError extends boolean = false>(
  options: Options<PracticeGetCourseData, ThrowOnError>,
) => {
  return (options.client ?? client).get<
    PracticeGetCourseResponses,
    PracticeGetCourseErrors,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/practice/courses/{episode_key}',
    ...options,
  });
};

/**
 * Synthesize Word
 */
export const practiceSynthesizeWord = <ThrowOnError extends boolean = false>(
  options: Options<PracticeSynthesizeWordData, ThrowOnError>,
) => {
  return (options.client ?? client).post<
    PracticeSynthesizeWordResponses,
    PracticeSynthesizeWordErrors,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/practice/tts/word',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });
};

/**
 * Gloss Line
 */
export const practiceGlossLine = <ThrowOnError extends boolean = false>(
  options: Options<PracticeGlossLineData, ThrowOnError>,
) => {
  return (options.client ?? client).post<
    PracticeGlossLineResponses,
    PracticeGlossLineErrors,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/practice/line-gloss',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });
};

/**
 * Translate Line
 */
export const practiceTranslateLine = <ThrowOnError extends boolean = false>(
  options: Options<PracticeTranslateLineData, ThrowOnError>,
) => {
  return (options.client ?? client).post<
    PracticeTranslateLineResponses,
    PracticeTranslateLineErrors,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/practice/translate-line',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });
};

/**
 * Translate Lines
 *
 * Batch translate for overlay prefetch (cache hits skip Cloud Translation).
 */
export const practiceTranslateLines = <ThrowOnError extends boolean = false>(
  options: Options<PracticeTranslateLinesData, ThrowOnError>,
) => {
  return (options.client ?? client).post<
    PracticeTranslateLinesResponses,
    PracticeTranslateLinesErrors,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/practice/translate-lines',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });
};

/**
 * Explain Line
 *
 * Stream a markdown grammar/vocabulary explanation of one subtitle line.
 *
 * The conversation lives entirely on the client: it sends the full transcript
 * each turn and we store nothing.
 */
export const practiceExplainLine = <ThrowOnError extends boolean = false>(
  options: Options<PracticeExplainLineData, ThrowOnError>,
) => {
  return (options.client ?? client).post<
    PracticeExplainLineResponses,
    PracticeExplainLineErrors,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/practice/explain',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });
};

/**
 * Speak Check
 *
 * Upload a Speak recording; Deepgram transcribes and we score accuracy.
 */
export const practiceSpeakCheck = <ThrowOnError extends boolean = false>(
  options: Options<PracticeSpeakCheckData, ThrowOnError>,
) => {
  return (options.client ?? client).post<
    PracticeSpeakCheckResponses,
    PracticeSpeakCheckErrors,
    ThrowOnError
  >({
    ...formDataBodySerializer,
    responseType: 'json',
    url: '/practice/speak-check',
    ...options,
    headers: {
      'Content-Type': null,
      ...options.headers,
    },
  });
};

/**
 * Record Word Events
 *
 * Lines the viewer saw and words they looked up or heard, batched by the extension.
 */
export const practiceRecordWordEvents = <ThrowOnError extends boolean = false>(
  options: Options<PracticeRecordWordEventsData, ThrowOnError>,
) => {
  return (options.client ?? client).post<
    PracticeRecordWordEventsResponses,
    PracticeRecordWordEventsErrors,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/practice/words/events',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });
};

/**
 * Set Word Status
 */
export const practiceSetWordStatus = <ThrowOnError extends boolean = false>(
  options: Options<PracticeSetWordStatusData, ThrowOnError>,
) => {
  return (options.client ?? client).post<
    PracticeSetWordStatusResponses,
    PracticeSetWordStatusErrors,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/practice/words/status',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });
};

/**
 * List Words
 */
export const practiceListWords = <ThrowOnError extends boolean = false>(
  options: Options<PracticeListWordsData, ThrowOnError>,
) => {
  return (options.client ?? client).get<
    PracticeListWordsResponses,
    PracticeListWordsErrors,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/practice/words',
    ...options,
  });
};

/**
 * Word Statuses
 */
export const practiceGetWordStatuses = <ThrowOnError extends boolean = false>(
  options: Options<PracticeGetWordStatusesData, ThrowOnError>,
) => {
  return (options.client ?? client).get<
    PracticeGetWordStatusesResponses,
    PracticeGetWordStatusesErrors,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/practice/words/statuses',
    ...options,
  });
};

/**
 * Listen Beat
 *
 * Playback heartbeat; listening time is credited from the server clock.
 */
export const practiceListenBeat = <ThrowOnError extends boolean = false>(
  options: Options<PracticeListenBeatData, ThrowOnError>,
) => {
  return (options.client ?? client).post<
    PracticeListenBeatResponses,
    PracticeListenBeatErrors,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/practice/listen',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });
};

/**
 * Get Stats
 */
export const practiceGetStats = <ThrowOnError extends boolean = false>(
  options: Options<PracticeGetStatsData, ThrowOnError>,
) => {
  return (options.client ?? client).get<
    PracticeGetStatsResponses,
    PracticeGetStatsErrors,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/practice/stats',
    ...options,
  });
};

/**
 * Get Review
 */
export const practiceGetReview = <ThrowOnError extends boolean = false>(
  options: Options<PracticeGetReviewData, ThrowOnError>,
) => {
  return (options.client ?? client).get<
    PracticeGetReviewResponses,
    PracticeGetReviewErrors,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/practice/review',
    ...options,
  });
};

/**
 * Get Leaderboard
 */
export const practiceGetLeaderboard = <ThrowOnError extends boolean = false>(
  options?: Options<PracticeGetLeaderboardData, ThrowOnError>,
) => {
  return (options?.client ?? client).get<
    PracticeGetLeaderboardResponses,
    PracticeGetLeaderboardErrors,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/practice/leaderboard',
    ...options,
  });
};

/**
 * Stream Word Audio
 *
 * Stream cached MP3 so the extension does not need direct GCS access.
 */
export const practiceStreamWordAudio = <ThrowOnError extends boolean = false>(
  options: Options<PracticeStreamWordAudioData, ThrowOnError>,
) => {
  return (options.client ?? client).get<
    PracticeStreamWordAudioResponses,
    PracticeStreamWordAudioErrors,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/practice/tts/word/audio',
    ...options,
  });
};

/**
 * Check Providers Health
 */
export const checkProvidersHealthHealthProvidersGet = <
  ThrowOnError extends boolean = false,
>(
  options?: Options<CheckProvidersHealthHealthProvidersGetData, ThrowOnError>,
) => {
  return (options?.client ?? client).get<
    CheckProvidersHealthHealthProvidersGetResponses,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/_health/providers',
    ...options,
  });
};

/**
 * List Demo Videos
 */
export const listDemoVideos = <ThrowOnError extends boolean = false>(
  options: Options<ListDemoVideosData, ThrowOnError>,
) => {
  return (options.client ?? client).get<
    ListDemoVideosResponses,
    ListDemoVideosErrors,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/demo-videos',
    ...options,
  });
};

/**
 * Create Demo Video
 *
 * Start generating a 30-second demo script with voiceover for a session.
 */
export const createDemoVideo = <ThrowOnError extends boolean = false>(
  options: Options<CreateDemoVideoData, ThrowOnError>,
) => {
  return (options.client ?? client).post<
    CreateDemoVideoResponses,
    CreateDemoVideoErrors,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/demo-videos',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });
};

/**
 * Get Demo Video
 */
export const getDemoVideo = <ThrowOnError extends boolean = false>(
  options: Options<GetDemoVideoData, ThrowOnError>,
) => {
  return (options.client ?? client).get<
    GetDemoVideoResponses,
    GetDemoVideoErrors,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/demo-videos/{demo_video_id}',
    ...options,
  });
};

/**
 * Get Auth Request
 */
export const getMcpAuthRequest = <ThrowOnError extends boolean = false>(
  options: Options<GetMcpAuthRequestData, ThrowOnError>,
) => {
  return (options.client ?? client).get<
    GetMcpAuthRequestResponses,
    GetMcpAuthRequestErrors,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/mcp-oauth/requests/{request_id}',
    ...options,
  });
};

/**
 * Approve Auth Request
 */
export const approveMcpAuthRequest = <ThrowOnError extends boolean = false>(
  options: Options<ApproveMcpAuthRequestData, ThrowOnError>,
) => {
  return (options.client ?? client).post<
    ApproveMcpAuthRequestResponses,
    ApproveMcpAuthRequestErrors,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/mcp-oauth/requests/{request_id}/approve',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });
};

/**
 * Deny Auth Request
 */
export const denyMcpAuthRequest = <ThrowOnError extends boolean = false>(
  options: Options<DenyMcpAuthRequestData, ThrowOnError>,
) => {
  return (options.client ?? client).post<
    DenyMcpAuthRequestResponses,
    DenyMcpAuthRequestErrors,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/mcp-oauth/requests/{request_id}/deny',
    ...options,
  });
};

/**
 * List Connections
 */
export const listMcpConnections = <ThrowOnError extends boolean = false>(
  options?: Options<ListMcpConnectionsData, ThrowOnError>,
) => {
  return (options?.client ?? client).get<
    ListMcpConnectionsResponses,
    ListMcpConnectionsErrors,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/mcp-oauth/connections',
    ...options,
  });
};

/**
 * Revoke Connection
 */
export const revokeMcpConnection = <ThrowOnError extends boolean = false>(
  options: Options<RevokeMcpConnectionData, ThrowOnError>,
) => {
  return (options.client ?? client).delete<
    RevokeMcpConnectionResponses,
    RevokeMcpConnectionErrors,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/mcp-oauth/connections/{connection_id}',
    ...options,
  });
};
